export const transactionDeposits = {
  result: [
    {
      _id: '63206bf88977f2001ed34f53',
      userId: '601cd58656c4dd5b565191e9',
      amount: 25000,
      orderId: '63206bf78977f2001ed34f52',
      gateway: 'cashfree',
      status: 'pending',
      createdOn: '2022-09-13T11:39:36.043Z',
      modifiedOn: '2022-09-13T11:39:36.043Z',
      userDeposits: [],
      userCashbacks: [],
      userBonuses: []
    },
    {
      _id: '6281dc5228ad11001e32c7da',
      userId: '601cd58656c4dd5b565191e9',
      amount: 100000,
      orderId: '6281dc5228ad11001e32c7d9',
      gateway: 'cashfree',
      status: 'success',
      createdOn: '2022-05-16T05:08:34.746Z',
      modifiedOn: '2022-05-16T05:08:34.747Z',
      comment: 'Transaction pending',
      paymentMode: 'Wallet',
      transactionId: '885215624',
      userDeposits: [
        {
          _id: '6281dc5e28ad11001e32c7db',
          createdOn: '2022-05-16T05:08:46.419Z',
          modifiedOn: '2022-05-16T05:08:46.420Z',
          deletedOn: null,
          userId: '601cd58656c4dd5b565191e9',
          transactionId: '6281dc5228ad11001e32c7da',
          transactionType: 'credit',
          amount: 100000,
          tax: 0,
          transfer: true,
          refund: false,
          balance: 19617420,
          entityType: 'TRANSACTIONAL'
        }
      ],
      userCashbacks: [],
      userBonuses: []
    },
    {
      _id: '6266995a26378a002348f42f',
      userId: '601cd58656c4dd5b565191e9',
      amount: 25000,
      orderId: '6266995926378a002348f42e',
      gateway: 'paytm',
      status: 'pending',
      createdOn: '2022-04-25T12:51:38.127Z',
      modifiedOn: '2022-04-25T12:51:38.127Z',
      userDeposits: [],
      userCashbacks: [],
      userBonuses: []
    },
    {
      _id: '6266991626378a002348f42d',
      userId: '601cd58656c4dd5b565191e9',
      amount: 100000,
      orderId: '6266991626378a002348f42c',
      gateway: 'paytm',
      status: 'pending',
      createdOn: '2022-04-25T12:50:30.969Z',
      modifiedOn: '2022-04-25T12:50:30.969Z',
      userDeposits: [],
      userCashbacks: [],
      userBonuses: []
    },
    {
      _id: '626698a126378a002348f42b',
      userId: '601cd58656c4dd5b565191e9',
      amount: 50000,
      orderId: '626698a126378a002348f42a',
      gateway: 'paytm',
      status: 'pending',
      createdOn: '2022-04-25T12:48:33.723Z',
      modifiedOn: '2022-04-25T12:48:33.723Z',
      userDeposits: [],
      userCashbacks: [],
      userBonuses: []
    },
    {
      _id: '626697b126378a002348f429',
      userId: '601cd58656c4dd5b565191e9',
      amount: 50000,
      orderId: '626697b126378a002348f428',
      gateway: 'paytm',
      status: 'pending',
      createdOn: '2022-04-25T12:44:33.667Z',
      modifiedOn: '2022-04-25T12:44:33.668Z',
      userDeposits: [],
      userCashbacks: [],
      userBonuses: []
    },
    {
      _id: '62664ce626378a002348f3dd',
      userId: '601cd58656c4dd5b565191e9',
      amount: 25000,
      orderId: '62664ce626378a002348f3dc',
      gateway: 'paytm',
      status: 'success',
      createdOn: '2022-04-25T07:25:26.280Z',
      modifiedOn: '2022-04-25T07:25:26.280Z',
      bankAccountId: null,
      bankTransactionId: '15528141001',
      comment: null,
      coupon: null,
      modifiedBy: null,
      paymentMode: null,
      redirectUrl: null,
      transactionId: '20220425111212800110168980103637747',
      userDeposits: [
        {
          _id: '62664cf126378a002348f3de',
          createdOn: '2022-04-25T07:25:37.284Z',
          modifiedOn: '2022-04-25T07:25:37.284Z',
          deletedOn: null,
          userId: '601cd58656c4dd5b565191e9',
          transactionId: '62664ce626378a002348f3dd',
          transactionType: 'credit',
          amount: 25000,
          tax: 0,
          transfer: true,
          refund: false,
          balance: 19549020,
          entityType: 'TRANSACTIONAL'
        }
      ],
      userCashbacks: [],
      userBonuses: []
    },
    {
      _id: '6260fddc429b650022f6b72d',
      userId: '601cd58656c4dd5b565191e9',
      amount: 100000,
      orderId: '6260fddb429b650022f6b72c',
      gateway: 'paytm',
      status: 'success',
      createdOn: '2022-04-21T06:46:52.110Z',
      modifiedOn: '2022-04-21T06:46:52.110Z',
      bankAccountId: null,
      bankTransactionId: '15085530445',
      comment: null,
      coupon: null,
      modifiedBy: null,
      paymentMode: null,
      redirectUrl: null,
      transactionId: '20220421111212800110168146403613930',
      userDeposits: [
        {
          _id: '6260fdf6429b650022f6b72e',
          createdOn: '2022-04-21T06:47:18.751Z',
          modifiedOn: '2022-04-21T06:47:18.752Z',
          deletedOn: null,
          userId: '601cd58656c4dd5b565191e9',
          transactionId: '6260fddc429b650022f6b72d',
          transactionType: 'credit',
          amount: 100000,
          tax: 0,
          transfer: true,
          refund: false,
          balance: 19524020,
          entityType: 'TRANSACTIONAL'
        }
      ],
      userCashbacks: [],
      userBonuses: []
    },
    {
      _id: '6260fdd4429b650022f6b72b',
      userId: '601cd58656c4dd5b565191e9',
      amount: 100000,
      orderId: '6260fdd4429b650022f6b72a',
      gateway: 'paytm',
      status: 'pending',
      createdOn: '2022-04-21T06:46:44.464Z',
      modifiedOn: '2022-04-21T06:46:44.464Z',
      userDeposits: [],
      userCashbacks: [],
      userBonuses: []
    },
    {
      _id: '6260fdcb429b650022f6b729',
      userId: '601cd58656c4dd5b565191e9',
      amount: 100000,
      orderId: '6260fdcb429b650022f6b728',
      gateway: 'paytm',
      status: 'pending',
      createdOn: '2022-04-21T06:46:35.355Z',
      modifiedOn: '2022-04-21T06:46:35.356Z',
      userDeposits: [],
      userCashbacks: [],
      userBonuses: []
    },
    {
      _id: '62333be7ddabeb001f0f7203',
      userId: '601cd58656c4dd5b565191e9',
      amount: 100000,
      orderId: '62333be7ddabeb001f0f7202',
      gateway: 'cashfree',
      status: 'cancelled',
      createdOn: '2022-03-17T13:47:19.262Z',
      modifiedOn: '2022-03-17T13:47:19.262Z',
      redirectUrl: '',
      comment: 'Cancelled by user',
      paymentMode: 'N/A',
      transactionId: 'N/A',
      userDeposits: [],
      userCashbacks: [],
      userBonuses: []
    },
    {
      _id: '62333bbcddabeb001f0f7201',
      userId: '601cd58656c4dd5b565191e9',
      amount: 50000,
      orderId: '62333bbbddabeb001f0f7200',
      gateway: 'paytm',
      status: 'failure',
      createdOn: '2022-03-17T13:46:36.426Z',
      modifiedOn: '2022-03-17T13:46:36.427Z',
      redirectUrl: '',
      bankAccountId: null,
      bankTransactionId: '',
      comment: null,
      coupon: null,
      modifiedBy: null,
      paymentMode: null,
      transactionId: '20220317111212800110168650203544014',
      userDeposits: [],
      userCashbacks: [],
      userBonuses: []
    },
    {
      _id: '623070fe135366001eca65dd',
      userId: '601cd58656c4dd5b565191e9',
      amount: 100000,
      orderId: '623070fe135366001eca65dc',
      gateway: 'cashfree',
      status: 'success',
      createdOn: '2022-03-15T10:57:02.703Z',
      modifiedOn: '2022-03-15T10:57:02.704Z',
      redirectUrl: '',
      comment: 'Transaction Successful',
      paymentMode: 'Wallet',
      transactionId: '1388251',
      userDeposits: [
        {
          _id: '623071035aa9b1001e96e5fe',
          createdOn: '2022-03-15T10:57:07.875Z',
          modifiedOn: '2022-03-15T10:57:07.875Z',
          deletedOn: null,
          userId: '601cd58656c4dd5b565191e9',
          transactionId: '623070fe135366001eca65dd',
          transactionType: 'credit',
          amount: 100000,
          tax: 0,
          transfer: true,
          refund: false,
          balance: 19570070,
          entityType: 'TRANSACTIONAL'
        }
      ],
      userCashbacks: [],
      userBonuses: []
    },
    {
      _id: '623070efffd21d001e9c3a43',
      userId: '601cd58656c4dd5b565191e9',
      amount: 25000,
      orderId: '623070efffd21d001e9c3a42',
      gateway: 'paytm',
      status: 'success',
      createdOn: '2022-03-15T10:56:47.311Z',
      modifiedOn: '2022-03-15T10:56:47.311Z',
      redirectUrl: '',
      bankAccountId: null,
      bankTransactionId: '18772991937',
      comment: null,
      coupon: null,
      modifiedBy: null,
      paymentMode: null,
      transactionId: '20220315111212800110168181003559072',
      userDeposits: [
        {
          _id: '623070f6135366001eca65db',
          createdOn: '2022-03-15T10:56:54.453Z',
          modifiedOn: '2022-03-15T10:56:54.453Z',
          deletedOn: null,
          userId: '601cd58656c4dd5b565191e9',
          transactionId: '623070efffd21d001e9c3a43',
          transactionType: 'credit',
          amount: 25000,
          tax: 0,
          transfer: true,
          refund: false,
          balance: 19470070,
          entityType: 'TRANSACTIONAL'
        }
      ],
      userCashbacks: [],
      userBonuses: []
    },
    {
      _id: '62307079135366001eca65d5',
      userId: '601cd58656c4dd5b565191e9',
      amount: 100000,
      orderId: '62307078135366001eca65d4',
      gateway: 'cashfree',
      status: 'success',
      createdOn: '2022-03-15T10:54:49.000Z',
      modifiedOn: '2022-03-15T10:54:49.001Z',
      redirectUrl: '',
      comment: 'Transaction Successful',
      paymentMode: 'Wallet',
      transactionId: '1388246',
      userDeposits: [
        {
          _id: '623070805aa9b1001e96e5f9',
          createdOn: '2022-03-15T10:54:56.413Z',
          modifiedOn: '2022-03-15T10:54:56.413Z',
          deletedOn: null,
          userId: '601cd58656c4dd5b565191e9',
          transactionId: '62307079135366001eca65d5',
          transactionType: 'credit',
          amount: 100000,
          tax: 0,
          transfer: true,
          refund: false,
          balance: 19445070,
          entityType: 'TRANSACTIONAL'
        }
      ],
      userCashbacks: [],
      userBonuses: []
    },
    {
      _id: '623070545aa9b1001e96e5f8',
      userId: '601cd58656c4dd5b565191e9',
      amount: 100000,
      orderId: '623070545aa9b1001e96e5f7',
      gateway: 'cashfree',
      status: 'success',
      createdOn: '2022-03-15T10:54:12.136Z',
      modifiedOn: '2022-03-15T10:54:12.136Z',
      redirectUrl: '',
      comment: 'Transaction Successful',
      paymentMode: 'Wallet',
      transactionId: '1388245',
      userDeposits: [
        {
          _id: '6230705b135366001eca65d3',
          createdOn: '2022-03-15T10:54:19.173Z',
          modifiedOn: '2022-03-15T10:54:19.174Z',
          deletedOn: null,
          userId: '601cd58656c4dd5b565191e9',
          transactionId: '623070545aa9b1001e96e5f8',
          transactionType: 'credit',
          amount: 100000,
          tax: 0,
          transfer: true,
          refund: false,
          balance: 19345070,
          entityType: 'TRANSACTIONAL'
        }
      ],
      userCashbacks: [],
      userBonuses: []
    },
    {
      _id: '623070415aa9b1001e96e5f5',
      userId: '601cd58656c4dd5b565191e9',
      amount: 25000,
      orderId: '623070405aa9b1001e96e5f4',
      gateway: 'paytm',
      status: 'success',
      createdOn: '2022-03-15T10:53:53.012Z',
      modifiedOn: '2022-03-15T10:53:53.013Z',
      redirectUrl: '',
      bankAccountId: null,
      bankTransactionId: '18018452199',
      comment: null,
      coupon: null,
      modifiedBy: null,
      paymentMode: null,
      transactionId: '20220315111212800110168088604584470',
      userDeposits: [
        {
          _id: '6230704c5aa9b1001e96e5f6',
          createdOn: '2022-03-15T10:54:04.662Z',
          modifiedOn: '2022-03-15T10:54:04.663Z',
          deletedOn: null,
          userId: '601cd58656c4dd5b565191e9',
          transactionId: '623070415aa9b1001e96e5f5',
          transactionType: 'credit',
          amount: 25000,
          tax: 0,
          transfer: true,
          refund: false,
          balance: 19245070,
          entityType: 'TRANSACTIONAL'
        }
      ],
      userCashbacks: [],
      userBonuses: []
    },
    {
      _id: '62306e5c135366001eca64f5',
      userId: '601cd58656c4dd5b565191e9',
      amount: 50000,
      orderId: '62306e5c135366001eca64f4',
      gateway: 'paytm',
      status: 'success',
      createdOn: '2022-03-15T10:45:48.564Z',
      modifiedOn: '2022-03-15T10:45:48.564Z',
      redirectUrl: '',
      bankAccountId: null,
      bankTransactionId: '19329374015',
      comment: null,
      coupon: null,
      modifiedBy: null,
      paymentMode: null,
      transactionId: '20220315111212800110168288703533635',
      userDeposits: [
        {
          _id: '62306e65135366001eca64f6',
          createdOn: '2022-03-15T10:45:57.320Z',
          modifiedOn: '2022-03-15T10:45:57.320Z',
          deletedOn: null,
          userId: '601cd58656c4dd5b565191e9',
          transactionId: '62306e5c135366001eca64f5',
          transactionType: 'credit',
          amount: 50000,
          tax: 0,
          transfer: true,
          refund: false,
          balance: 19220070,
          entityType: 'TRANSACTIONAL'
        }
      ],
      userCashbacks: [],
      userBonuses: []
    },
    {
      _id: '62306e14ffd21d001e9c39c7',
      userId: '601cd58656c4dd5b565191e9',
      amount: 25000,
      orderId: '62306e14ffd21d001e9c39c6',
      gateway: 'paytm',
      status: 'pending',
      createdOn: '2022-03-15T10:44:36.635Z',
      modifiedOn: '2022-03-15T10:44:36.635Z',
      redirectUrl: '',
      userDeposits: [],
      userCashbacks: [],
      userBonuses: []
    },
    {
      _id: '62306b87135366001eca64c9',
      userId: '601cd58656c4dd5b565191e9',
      amount: 100000,
      orderId: '62306b86135366001eca64c8',
      gateway: 'cashfree',
      status: 'success',
      createdOn: '2022-03-15T10:33:43.039Z',
      modifiedOn: '2022-03-15T10:33:43.039Z',
      redirectUrl: '',
      comment: 'Transaction Successful',
      paymentMode: 'Wallet',
      transactionId: '1388150',
      userDeposits: [
        {
          _id: '62306b8e5aa9b1001e96e583',
          createdOn: '2022-03-15T10:33:50.996Z',
          modifiedOn: '2022-03-15T10:33:50.996Z',
          deletedOn: null,
          userId: '601cd58656c4dd5b565191e9',
          transactionId: '62306b87135366001eca64c9',
          transactionType: 'credit',
          amount: 100000,
          tax: 0,
          transfer: true,
          refund: false,
          balance: 19170070,
          entityType: 'TRANSACTIONAL'
        }
      ],
      userCashbacks: [],
      userBonuses: []
    },
    {
      _id: '6230686d135366001eca64bf',
      userId: '601cd58656c4dd5b565191e9',
      amount: 100000,
      orderId: '6230686d135366001eca64be',
      gateway: 'cashfree',
      status: 'success',
      createdOn: '2022-03-15T10:20:29.053Z',
      modifiedOn: '2022-03-15T10:20:29.053Z',
      redirectUrl: '',
      comment: 'Transaction Successful',
      paymentMode: 'Wallet',
      transactionId: '1388083',
      userDeposits: [
        {
          _id: '62306873135366001eca64c0',
          createdOn: '2022-03-15T10:20:35.694Z',
          modifiedOn: '2022-03-15T10:20:35.695Z',
          deletedOn: null,
          userId: '601cd58656c4dd5b565191e9',
          transactionId: '6230686d135366001eca64bf',
          transactionType: 'credit',
          amount: 100000,
          tax: 0,
          transfer: true,
          refund: false,
          balance: 19070070,
          entityType: 'TRANSACTIONAL'
        }
      ],
      userCashbacks: [],
      userBonuses: []
    },
    {
      _id: '62306805ffd21d001e9c3996',
      userId: '601cd58656c4dd5b565191e9',
      amount: 100000,
      orderId: '62306805ffd21d001e9c3995',
      gateway: 'cashfree',
      status: 'pending',
      createdOn: '2022-03-15T10:18:45.522Z',
      modifiedOn: '2022-03-15T10:18:45.522Z',
      redirectUrl: '',
      userDeposits: [],
      userCashbacks: [],
      userBonuses: []
    },
    {
      _id: '623067e05aa9b1001e96e57f',
      userId: '601cd58656c4dd5b565191e9',
      amount: 100000,
      orderId: '623067e05aa9b1001e96e57e',
      gateway: 'cashfree',
      status: 'pending',
      createdOn: '2022-03-15T10:18:08.641Z',
      modifiedOn: '2022-03-15T10:18:08.642Z',
      redirectUrl: '',
      userDeposits: [],
      userCashbacks: [],
      userBonuses: []
    },
    {
      _id: '62306781ffd21d001e9c3994',
      userId: '601cd58656c4dd5b565191e9',
      amount: 100000,
      orderId: '62306781ffd21d001e9c3993',
      gateway: 'cashfree',
      status: 'pending',
      createdOn: '2022-03-15T10:16:33.722Z',
      modifiedOn: '2022-03-15T10:16:33.722Z',
      redirectUrl: '',
      userDeposits: [],
      userCashbacks: [],
      userBonuses: []
    },
    {
      _id: '62306745135366001eca64bd',
      userId: '601cd58656c4dd5b565191e9',
      amount: 100000,
      orderId: '62306745135366001eca64bc',
      gateway: 'cashfree',
      status: 'pending',
      createdOn: '2022-03-15T10:15:33.294Z',
      modifiedOn: '2022-03-15T10:15:33.294Z',
      redirectUrl: '',
      userDeposits: [],
      userCashbacks: [],
      userBonuses: []
    }
  ],
  count: 494
};
export const transactionWithdrawals = {
  result: [
    {
      _id: '632423118977f2001ed3505d',
      userId: '601cd58656c4dd5b565191e9',
      amount: 20000,
      orderId: '632423108977f2001ed3505c',
      gateway: 'cashfree',
      destination: 'bank',
      beneficiaryId: '632077fa8977f2001ed34f65',
      purpose: 'OTHERS',
      comment: 'IGamio Bank withdrawal',
      status: 'accepted',
      createdOn: '2022-09-16T07:17:37.197Z',
      modifiedOn: '2022-09-16T07:17:37.197Z',
      modifiedBy: '5fcfa2fe6d6b0312af1607a6',
      transactionId: '23646642'
    },
    {
      _id: '6320704c8977f2001ed34f5f',
      userId: '601cd58656c4dd5b565191e9',
      amount: 20000,
      orderId: '6320704c8977f2001ed34f5e',
      gateway: 'cashfree',
      destination: 'bank',
      beneficiaryId: '6269434256f1280022a0fe16',
      purpose: 'OTHERS',
      comment: 'IGamio Bank withdrawal',
      status: 'accepted',
      createdOn: '2022-09-13T11:58:04.774Z',
      modifiedOn: '2022-09-13T11:58:04.774Z',
      modifiedBy: '5fcfa2fe6d6b0312af1607a6',
      transactionId: '23646638'
    }
  ],
  count: 2
};
export const transactionGames = {
  result: [
    {
      _id: '63d33fcb41856f0011f95386',
      entryFee: 5000,
      bonusFee: 250,
      gameId: '63cb7f5d41856f0011f9500e',
      game: 'fantasyFootball',
      matchTitle: 'JFC vs MCFC',
      userId: '5fd32b93eaf661ea51eae8af',
      createdOn: '2023-01-27T03:06:51.794Z',
      modifiedOn: '2023-01-27T14:03:05.964Z',
      primaryWalletPayment: [],
      gameWalletPayment: [
        {
          _id: '63d33fcb41856f0011f95388',
          teamId: '63d33fcb41856f0011f95385',
          createdOn: '2023-01-27T03:06:51.794Z',
          transactionType: 'debit',
          amount: 4750,
          balance: 830965.42,
          modifiedOn: '2023-01-27T14:03:05.964Z'
        },
        {
          _id: '63d3d999b98086516a7c99ab',
          amount: 4750,
          balance: 836665.42,
          createdOn: '2023-01-27T14:03:05.979Z',
          modifiedOn: '2023-01-27T14:03:05.979Z',
          refund: true,
          teamId: '63d33fcb41856f0011f95385',
          transactionType: 'credit'
        }
      ],
      pokerWalletPayment: [],
      bonusWalletPayment: [
        {
          _id: '63d33fcb41856f0011f95387',
          teamId: '63d33fcb41856f0011f95385',
          createdOn: '2023-01-27T03:06:51.794Z',
          transactionType: 'debit',
          amount: 250,
          balance: 4700,
          modifiedOn: '2023-01-27T14:03:05.964Z'
        },
        {
          _id: '63d3d999b98086516a7c99a9',
          amount: 250,
          balance: 5000,
          createdOn: '2023-01-27T14:03:05.978Z',
          modifiedOn: '2023-01-27T14:03:05.978Z',
          refund: true,
          teamId: '63d33fcb41856f0011f95385',
          transactionType: 'credit'
        }
      ],
      cashbackWalletPayment: []
    },
    {
      _id: '63d28a47b5afcb001d0ad658',
      entryFee: 500,
      bonusFee: 25,
      gameId: '63d16d3fb5afcb001d0ad130',
      game: 'fantasyCricket',
      matchTitle: 'ENG-W vs AUS-W',
      userId: '5fd32b93eaf661ea51eae8af',
      createdOn: '2023-01-26T14:12:23.033Z',
      modifiedOn: '2023-01-27T11:48:00.317Z',
      primaryWalletPayment: [],
      gameWalletPayment: [
        {
          _id: '63d28a47b5afcb001d0ad65a',
          teamId: '63d28a47b5afcb001d0ad657',
          createdOn: '2023-01-26T14:12:23.033Z',
          transactionType: 'debit',
          amount: 475,
          balance: 836190.42,
          modifiedOn: '2023-01-27T11:48:00.317Z'
        },
        {
          _id: '63d28b40714ebb001dbb34d4',
          teamId: '63d28b40714ebb001dbb34d1',
          createdOn: '2023-01-26T14:16:32.269Z',
          transactionType: 'debit',
          amount: 475,
          balance: 835715.42,
          modifiedOn: '2023-01-27T11:48:00.671Z'
        },
        {
          _id: '63d3b9f0b98086516a760add',
          amount: 475,
          balance: 831440.42,
          createdOn: '2023-01-27T11:48:00.364Z',
          modifiedOn: '2023-01-27T11:48:00.364Z',
          refund: true,
          teamId: '63d28a47b5afcb001d0ad657',
          transactionType: 'credit'
        },
        {
          _id: '63d3b9f0b98086516a760b0e',
          amount: 475,
          balance: 831915.42,
          createdOn: '2023-01-27T11:48:00.682Z',
          modifiedOn: '2023-01-27T11:48:00.682Z',
          refund: true,
          teamId: '63d28b40714ebb001dbb34d1',
          transactionType: 'credit'
        }
      ],
      pokerWalletPayment: [],
      bonusWalletPayment: [
        {
          _id: '63d28a47b5afcb001d0ad659',
          teamId: '63d28a47b5afcb001d0ad657',
          createdOn: '2023-01-26T14:12:23.033Z',
          transactionType: 'debit',
          amount: 25,
          balance: 4975,
          modifiedOn: '2023-01-27T11:48:00.317Z'
        },
        {
          _id: '63d28b40714ebb001dbb34d3',
          teamId: '63d28b40714ebb001dbb34d1',
          createdOn: '2023-01-26T14:16:32.269Z',
          transactionType: 'debit',
          amount: 25,
          balance: 4950,
          modifiedOn: '2023-01-27T11:48:00.671Z'
        },
        {
          _id: '63d3b9f0b98086516a760ad7',
          amount: 25,
          balance: 4725,
          createdOn: '2023-01-27T11:48:00.363Z',
          modifiedOn: '2023-01-27T11:48:00.363Z',
          refund: true,
          teamId: '63d28a47b5afcb001d0ad657',
          transactionType: 'credit'
        },
        {
          _id: '63d3b9f0b98086516a760b0c',
          amount: 25,
          balance: 4750,
          createdOn: '2023-01-27T11:48:00.681Z',
          modifiedOn: '2023-01-27T11:48:00.681Z',
          refund: true,
          teamId: '63d28b40714ebb001dbb34d1',
          transactionType: 'credit'
        }
      ],
      cashbackWalletPayment: []
    },
    {
      _id: '63c109604d1c0e001debe65c',
      entryFee: 300,
      bonusFee: 0,
      gameId: '63be89524d1c0e001debd462',
      game: 'fantasyCricket',
      matchTitle: 'PAK vs NZ',
      userId: '5fd32b93eaf661ea51eae8af',
      createdOn: '2023-01-13T07:33:52.758Z',
      primaryWalletPayment: [],
      gameWalletPayment: [
        {
          _id: '63c109604d1c0e001debe65d',
          teamId: '63c109604d1c0e001debe65b',
          createdOn: '2023-01-13T07:33:52.758Z',
          transactionType: 'debit',
          amount: 300,
          balance: 836665.42
        }
      ],
      pokerWalletPayment: [],
      bonusWalletPayment: [],
      cashbackWalletPayment: []
    },
    {
      _id: '63bff17641856f0011f94c1d',
      entryFee: 1400,
      bonusFee: 0,
      gameId: '63bfe84f4b1731001196732f',
      game: 'fantasyFootball',
      matchTitle: 'FAT vs ETT',
      userId: '5fd32b93eaf661ea51eae8af',
      createdOn: '2023-01-12T11:39:34.698Z',
      primaryWalletPayment: [],
      gameWalletPayment: [
        {
          _id: '63bff17641856f0011f94c1e',
          teamId: '63bff17641856f0011f94c1c',
          createdOn: '2023-01-12T11:39:34.698Z',
          transactionType: 'debit',
          amount: 1400,
          balance: 836965.42
        }
      ],
      pokerWalletPayment: [],
      bonusWalletPayment: [],
      cashbackWalletPayment: []
    },
    {
      _id: '6339909629a44d001d392aaa',
      entryFee: 300,
      bonusFee: 0,
      gameId: '633463af29a44d001d38f039',
      game: 'fantasyCricket',
      matchTitle: 'IND vs SA',
      userId: '5fd32b93eaf661ea51eae8af',
      createdOn: '2022-10-02T13:22:30.991Z',
      modifiedOn: '2022-10-02T18:03:31.794Z',
      primaryWalletPayment: [],
      gameWalletPayment: [
        {
          _id: '6339909629a44d001d392ab0',
          teamId: '6339909629a44d001d392aa4',
          createdOn: '2022-10-02T13:22:30.991Z',
          transactionType: 'debit',
          amount: 300,
          balance: 830565.42
        },
        {
          _id: '6339909629a44d001d392ab1',
          teamId: '6339909629a44d001d392aa5',
          createdOn: '2022-10-02T13:22:30.991Z',
          transactionType: 'debit',
          amount: 300,
          balance: 830265.42
        },
        {
          _id: '6339909629a44d001d392ab2',
          teamId: '6339909629a44d001d392aa6',
          createdOn: '2022-10-02T13:22:30.991Z',
          transactionType: 'debit',
          amount: 300,
          balance: 829965.42
        },
        {
          _id: '6339909629a44d001d392ab3',
          teamId: '6339909629a44d001d392aa7',
          createdOn: '2022-10-02T13:22:30.991Z',
          transactionType: 'debit',
          amount: 300,
          balance: 829665.42
        },
        {
          _id: '6339909629a44d001d392ab4',
          teamId: '6339909629a44d001d392aa8',
          createdOn: '2022-10-02T13:22:30.991Z',
          transactionType: 'debit',
          amount: 300,
          balance: 829365.42
        },
        {
          _id: '6339909629a44d001d392ab5',
          teamId: '6339909629a44d001d392aa9',
          createdOn: '2022-10-02T13:22:30.991Z',
          transactionType: 'debit',
          amount: 300,
          balance: 829065.42
        },
        {
          _id: '6339d2732ebe32ec417cd22f',
          teamId: '6339909629a44d001d392aa7',
          transactionType: 'credit',
          balance: 829365.42,
          amount: 300,
          createdOn: '2022-10-02T18:03:31.130Z',
          tax: 0
        },
        {
          _id: '6339d2732ebe32ec417cd28d',
          teamId: '6339909629a44d001d392aa5',
          transactionType: 'credit',
          balance: 829665.42,
          amount: 300,
          createdOn: '2022-10-02T18:03:31.481Z',
          tax: 0
        },
        {
          _id: '6339d2732ebe32ec417cd2a7',
          teamId: '6339909629a44d001d392aa4',
          transactionType: 'credit',
          balance: 829965.42,
          amount: 300,
          createdOn: '2022-10-02T18:03:31.794Z',
          tax: 0
        }
      ],
      pokerWalletPayment: [],
      bonusWalletPayment: [],
      cashbackWalletPayment: []
    },
    {
      _id: '6339908f29a44d001d392a8e',
      entryFee: 3100,
      bonusFee: 0,
      gameId: '633463af2dcd02001dbac805',
      game: 'fantasyCricket',
      matchTitle: 'IND vs SA',
      userId: '5fd32b93eaf661ea51eae8af',
      createdOn: '2022-10-02T13:22:23.553Z',
      modifiedOn: '2022-10-02T18:04:53.364Z',
      primaryWalletPayment: [],
      gameWalletPayment: [
        {
          _id: '6339908f29a44d001d392a94',
          teamId: '6339908f29a44d001d392a88',
          createdOn: '2022-10-02T13:22:23.553Z',
          transactionType: 'debit',
          amount: 3100,
          balance: 846365.42
        },
        {
          _id: '6339908f29a44d001d392a95',
          teamId: '6339908f29a44d001d392a89',
          createdOn: '2022-10-02T13:22:23.554Z',
          transactionType: 'debit',
          amount: 3100,
          balance: 843265.42
        },
        {
          _id: '6339908f29a44d001d392a96',
          teamId: '6339908f29a44d001d392a8a',
          createdOn: '2022-10-02T13:22:23.554Z',
          transactionType: 'debit',
          amount: 3100,
          balance: 840165.42
        },
        {
          _id: '6339908f29a44d001d392a97',
          teamId: '6339908f29a44d001d392a8b',
          createdOn: '2022-10-02T13:22:23.554Z',
          transactionType: 'debit',
          amount: 3100,
          balance: 837065.42
        },
        {
          _id: '6339908f29a44d001d392a98',
          teamId: '6339908f29a44d001d392a8c',
          createdOn: '2022-10-02T13:22:23.554Z',
          transactionType: 'debit',
          amount: 3100,
          balance: 833965.42
        },
        {
          _id: '6339908f29a44d001d392a99',
          teamId: '6339908f29a44d001d392a8d',
          createdOn: '2022-10-02T13:22:23.554Z',
          transactionType: 'debit',
          amount: 3100,
          balance: 830865.42
        },
        {
          _id: '6339d2c52ebe32ec417d156c',
          teamId: '6339908f29a44d001d392a88',
          transactionType: 'credit',
          balance: 832465.42,
          amount: 2500,
          createdOn: '2022-10-02T18:04:53.364Z',
          tax: 0
        },
        {
          _id: '6339d2c52ebe32ec417d158c',
          teamId: '6339908f29a44d001d392a89',
          transactionType: 'credit',
          balance: 835865.42,
          amount: 3400,
          createdOn: '2022-10-02T18:04:53.701Z',
          tax: 0
        },
        {
          _id: '6339d2c62ebe32ec417d15a1',
          teamId: '6339908f29a44d001d392a8b',
          transactionType: 'credit',
          balance: 838365.42,
          amount: 2500,
          createdOn: '2022-10-02T18:04:54.015Z',
          tax: 0
        }
      ],
      pokerWalletPayment: [],
      bonusWalletPayment: [],
      cashbackWalletPayment: []
    },
    {
      _id: '63174df76ed590001cad8549',
      entryFee: 3100,
      bonusFee: 0,
      gameId: '6314f2cb0aa9df001fa73152',
      game: 'fantasyCricket',
      matchTitle: 'IND vs SL',
      userId: '5fd32b93eaf661ea51eae8af',
      createdOn: '2022-09-06T13:41:11.770Z',
      modifiedOn: '2022-09-06T18:29:41.807Z',
      primaryWalletPayment: [],
      gameWalletPayment: [
        {
          _id: '63174df76ed590001cad854e',
          teamId: '63174df76ed590001cad8544',
          createdOn: '2022-09-06T13:41:11.770Z',
          transactionType: 'debit',
          amount: 3100,
          balance: 868665.42
        },
        {
          _id: '63174df76ed590001cad854f',
          teamId: '63174df76ed590001cad8545',
          createdOn: '2022-09-06T13:41:11.770Z',
          transactionType: 'debit',
          amount: 3100,
          balance: 865565.42
        },
        {
          _id: '63174df76ed590001cad8550',
          teamId: '63174df76ed590001cad8546',
          createdOn: '2022-09-06T13:41:11.770Z',
          transactionType: 'debit',
          amount: 3100,
          balance: 862465.42
        },
        {
          _id: '63174df76ed590001cad8551',
          teamId: '63174df76ed590001cad8547',
          createdOn: '2022-09-06T13:41:11.770Z',
          transactionType: 'debit',
          amount: 3100,
          balance: 859365.42
        },
        {
          _id: '63174df76ed590001cad8552',
          teamId: '63174df76ed590001cad8548',
          createdOn: '2022-09-06T13:41:11.770Z',
          transactionType: 'debit',
          amount: 3100,
          balance: 856265.42
        },
        {
          _id: '63179193574046ede41f3627',
          teamId: '63174df76ed590001cad8546',
          transactionType: 'credit',
          balance: 858765.42,
          amount: 2500,
          createdOn: '2022-09-06T18:29:38.754Z',
          tax: 0
        },
        {
          _id: '63179193574046ede41f36d0',
          teamId: '63174df76ed590001cad8545',
          transactionType: 'credit',
          balance: 861265.42,
          amount: 2500,
          createdOn: '2022-09-06T18:29:39.501Z',
          tax: 0
        },
        {
          _id: '63179194574046ede41f3768',
          teamId: '63174df76ed590001cad8548',
          transactionType: 'credit',
          balance: 864665.42,
          amount: 3400,
          createdOn: '2022-09-06T18:29:40.262Z',
          tax: 0
        },
        {
          _id: '63179195574046ede41f3836',
          teamId: '63174df76ed590001cad8547',
          transactionType: 'credit',
          balance: 867165.42,
          amount: 2500,
          createdOn: '2022-09-06T18:29:41.035Z',
          tax: 0
        },
        {
          _id: '63179196574046ede41f38d9',
          teamId: '63174df76ed590001cad8544',
          transactionType: 'credit',
          balance: 869665.42,
          amount: 2500,
          createdOn: '2022-09-06T18:29:41.807Z',
          tax: 0
        }
      ],
      pokerWalletPayment: [],
      bonusWalletPayment: [],
      cashbackWalletPayment: []
    },
    {
      _id: '6314ad13168fcd001e11d1e3',
      entryFee: 3100,
      bonusFee: 0,
      gameId: '6312d87c6ed590001cad3ca7',
      game: 'fantasyCricket',
      matchTitle: 'IND vs PAK',
      userId: '5fd32b93eaf661ea51eae8af',
      createdOn: '2022-09-04T13:50:11.403Z',
      modifiedOn: '2022-09-04T18:14:14.170Z',
      primaryWalletPayment: [],
      gameWalletPayment: [
        {
          _id: '6314ad13168fcd001e11d1e9',
          teamId: '6314ad13168fcd001e11d1dd',
          createdOn: '2022-09-04T13:50:11.403Z',
          transactionType: 'debit',
          amount: 3100,
          balance: 878332.42
        },
        {
          _id: '6314ad13168fcd001e11d1ea',
          teamId: '6314ad13168fcd001e11d1de',
          createdOn: '2022-09-04T13:50:11.403Z',
          transactionType: 'debit',
          amount: 3100,
          balance: 875232.42
        },
        {
          _id: '6314ad13168fcd001e11d1eb',
          teamId: '6314ad13168fcd001e11d1df',
          createdOn: '2022-09-04T13:50:11.403Z',
          transactionType: 'debit',
          amount: 3100,
          balance: 872132.42
        },
        {
          _id: '6314ad13168fcd001e11d1ec',
          teamId: '6314ad13168fcd001e11d1e0',
          createdOn: '2022-09-04T13:50:11.403Z',
          transactionType: 'debit',
          amount: 3100,
          balance: 869032.42
        },
        {
          _id: '6314ad13168fcd001e11d1ed',
          teamId: '6314ad13168fcd001e11d1e1',
          createdOn: '2022-09-04T13:50:11.403Z',
          transactionType: 'debit',
          amount: 3100,
          balance: 865932.42
        },
        {
          _id: '6314ad13168fcd001e11d1ee',
          teamId: '6314ad13168fcd001e11d1e2',
          createdOn: '2022-09-04T13:50:11.403Z',
          transactionType: 'debit',
          amount: 3100,
          balance: 862832.42
        },
        {
          _id: '6314eaf5574046ede49baebc',
          teamId: '6314ad13168fcd001e11d1de',
          transactionType: 'credit',
          balance: 869132.42,
          amount: 5500,
          createdOn: '2022-09-04T18:14:13.401Z',
          tax: 0
        },
        {
          _id: '6314eaf6574046ede49baf70',
          teamId: '6314ad13168fcd001e11d1dd',
          transactionType: 'credit',
          balance: 871765.42,
          amount: 2633,
          createdOn: '2022-09-04T18:14:14.170Z',
          tax: 0
        }
      ],
      pokerWalletPayment: [],
      bonusWalletPayment: [],
      cashbackWalletPayment: []
    },
    {
      _id: '6314ad0e6ed590001cad66b5',
      entryFee: 300,
      bonusFee: 0,
      gameId: '6312d87c168fcd001e11a80b',
      game: 'fantasyCricket',
      matchTitle: 'IND vs PAK',
      userId: '5fd32b93eaf661ea51eae8af',
      createdOn: '2022-09-04T13:50:06.013Z',
      modifiedOn: '2022-09-04T18:08:34.258Z',
      primaryWalletPayment: [],
      gameWalletPayment: [
        {
          _id: '6314ad0e6ed590001cad66bb',
          teamId: '6314ad0e6ed590001cad66af',
          createdOn: '2022-09-04T13:50:06.013Z',
          transactionType: 'debit',
          amount: 300,
          balance: 882932.42
        },
        {
          _id: '6314ad0e6ed590001cad66bc',
          teamId: '6314ad0e6ed590001cad66b0',
          createdOn: '2022-09-04T13:50:06.013Z',
          transactionType: 'debit',
          amount: 300,
          balance: 882632.42
        },
        {
          _id: '6314ad0e6ed590001cad66bd',
          teamId: '6314ad0e6ed590001cad66b1',
          createdOn: '2022-09-04T13:50:06.013Z',
          transactionType: 'debit',
          amount: 300,
          balance: 882332.42
        },
        {
          _id: '6314ad0e6ed590001cad66be',
          teamId: '6314ad0e6ed590001cad66b2',
          createdOn: '2022-09-04T13:50:06.013Z',
          transactionType: 'debit',
          amount: 300,
          balance: 882032.42
        },
        {
          _id: '6314ad0e6ed590001cad66bf',
          teamId: '6314ad0e6ed590001cad66b3',
          createdOn: '2022-09-04T13:50:06.013Z',
          transactionType: 'debit',
          amount: 300,
          balance: 881732.42
        },
        {
          _id: '6314ad0e6ed590001cad66c0',
          teamId: '6314ad0e6ed590001cad66b4',
          createdOn: '2022-09-04T13:50:06.013Z',
          transactionType: 'debit',
          amount: 300,
          balance: 881432.42
        },
        {
          _id: '6314e9a2574046ede49a5e44',
          teamId: '6314ad0e6ed590001cad66af',
          transactionType: 'credit',
          balance: 863132.42,
          amount: 300,
          createdOn: '2022-09-04T18:08:34.258Z',
          tax: 0
        },
        {
          _id: '6314e9a3574046ede49a5f29',
          teamId: '6314ad0e6ed590001cad66b0',
          transactionType: 'credit',
          balance: 863632.42,
          amount: 500,
          createdOn: '2022-09-04T18:08:35.590Z',
          tax: 0
        }
      ],
      pokerWalletPayment: [],
      bonusWalletPayment: [],
      cashbackWalletPayment: []
    },
    {
      _id: '630a21728affc500207aee18',
      entryFee: 300,
      bonusFee: 0,
      gameId: '630873abd344d0001f31021e',
      game: 'fantasyCricket',
      matchTitle: 'SL vs AFG',
      userId: '5fd32b93eaf661ea51eae8af',
      createdOn: '2022-08-27T13:51:46.065Z',
      primaryWalletPayment: [],
      gameWalletPayment: [
        {
          _id: '630a21728affc500207aee1f',
          teamId: '630a21728affc500207aee13',
          createdOn: '2022-08-27T13:51:46.065Z',
          transactionType: 'debit',
          amount: 300,
          balance: 882332.42
        },
        {
          _id: '630a21728affc500207aee20',
          teamId: '630a21728affc500207aee14',
          createdOn: '2022-08-27T13:51:46.065Z',
          transactionType: 'debit',
          amount: 300,
          balance: 882032.42
        },
        {
          _id: '630a21728affc500207aee1d',
          teamId: '630a21728affc500207aee11',
          createdOn: '2022-08-27T13:51:46.065Z',
          transactionType: 'debit',
          amount: 300,
          balance: 882932.42
        },
        {
          _id: '630a21728affc500207aee1e',
          teamId: '630a21728affc500207aee12',
          createdOn: '2022-08-27T13:51:46.065Z',
          transactionType: 'debit',
          amount: 300,
          balance: 882632.42
        },
        {
          _id: '630a21728affc500207aee21',
          teamId: '630a21728affc500207aee15',
          createdOn: '2022-08-27T13:51:46.065Z',
          transactionType: 'debit',
          amount: 300,
          balance: 881732.42
        },
        {
          _id: '630a21728affc500207aee22',
          teamId: '630a21728affc500207aee16',
          createdOn: '2022-08-27T13:51:46.065Z',
          transactionType: 'debit',
          amount: 300,
          balance: 881432.42
        },
        {
          _id: '630a22df102dac0020fbc259',
          teamId: '630a22df102dac0020fbc257',
          createdOn: '2022-08-27T13:57:51.275Z',
          transactionType: 'debit',
          amount: 300,
          balance: 878632.42
        },
        {
          _id: '630a533c07df9dadae98d206',
          teamId: '630a21728affc500207aee13',
          transactionType: 'credit',
          balance: 882932.42,
          amount: 300,
          createdOn: '2022-08-27T17:24:12.646Z',
          tax: 0
        },
        {
          _id: '630a533d07df9dadae98d2f4',
          teamId: '630a21728affc500207aee16',
          transactionType: 'credit',
          balance: 883232.42,
          amount: 300,
          createdOn: '2022-08-27T17:24:13.426Z',
          tax: 0
        }
      ],
      pokerWalletPayment: [],
      bonusWalletPayment: [],
      cashbackWalletPayment: []
    },
    {
      _id: '630a216b8affc500207aedfb',
      entryFee: 2500,
      bonusFee: 0,
      gameId: '630873ab9ed304001fcf068c',
      game: 'fantasyCricket',
      matchTitle: 'SL vs AFG',
      userId: '5fd32b93eaf661ea51eae8af',
      createdOn: '2022-08-27T13:51:39.926Z',
      primaryWalletPayment: [],
      gameWalletPayment: [
        {
          _id: '630a216b8affc500207aee03',
          teamId: '630a216b8affc500207aedf7',
          createdOn: '2022-08-27T13:51:39.926Z',
          transactionType: 'debit',
          amount: 2500,
          balance: 890732.42
        },
        {
          _id: '630a216b8affc500207aee04',
          teamId: '630a216b8affc500207aedf8',
          createdOn: '2022-08-27T13:51:39.926Z',
          transactionType: 'debit',
          amount: 2500,
          balance: 888232.42
        },
        {
          _id: '630a216b8affc500207aee05',
          teamId: '630a216b8affc500207aedf9',
          createdOn: '2022-08-27T13:51:39.926Z',
          transactionType: 'debit',
          amount: 2500,
          balance: 885732.42
        },
        {
          _id: '630a216b8affc500207aee06',
          teamId: '630a216b8affc500207aedfa',
          createdOn: '2022-08-27T13:51:39.926Z',
          transactionType: 'debit',
          amount: 2500,
          balance: 883232.42
        },
        {
          _id: '630a216b8affc500207aee01',
          teamId: '630a216b8affc500207aedf5',
          createdOn: '2022-08-27T13:51:39.926Z',
          transactionType: 'debit',
          amount: 2500,
          balance: 895732.42
        },
        {
          _id: '630a216b8affc500207aee02',
          teamId: '630a216b8affc500207aedf6',
          createdOn: '2022-08-27T13:51:39.926Z',
          transactionType: 'debit',
          amount: 2500,
          balance: 893232.42
        },
        {
          _id: '630a22d88affc500207af0f2',
          teamId: '630a22d88affc500207af0f0',
          createdOn: '2022-08-27T13:57:44.737Z',
          transactionType: 'debit',
          amount: 2500,
          balance: 878932.42
        },
        {
          _id: '630a531307df9dadae98a40c',
          teamId: '630a216b8affc500207aedf7',
          transactionType: 'credit',
          balance: 880632.42,
          amount: 2000,
          createdOn: '2022-08-27T17:23:30.968Z',
          tax: 0
        },
        {
          _id: '630a531807df9dadae98aa1b',
          teamId: '630a216b8affc500207aedfa',
          transactionType: 'credit',
          balance: 882632.42,
          amount: 2000,
          createdOn: '2022-08-27T17:23:36.508Z',
          tax: 0
        }
      ],
      pokerWalletPayment: [],
      bonusWalletPayment: [],
      cashbackWalletPayment: []
    },
    {
      _id: '630086e49ed304001fce9be7',
      entryFee: 300,
      bonusFee: 0,
      gameId: '62fe51c84e80da001d0d63cd',
      game: 'fantasyCricket',
      matchTitle: 'ZIM vs IND',
      userId: '5fd32b93eaf661ea51eae8af',
      createdOn: '2022-08-20T07:01:56.826Z',
      modifiedOn: '2022-08-20T16:27:58.296Z',
      primaryWalletPayment: [],
      gameWalletPayment: [
        {
          _id: '630086e49ed304001fce9bed',
          teamId: '630086e49ed304001fce9be1',
          createdOn: '2022-08-20T07:01:56.826Z',
          transactionType: 'debit',
          amount: 300,
          balance: 885432.42
        },
        {
          _id: '630086e49ed304001fce9bee',
          teamId: '630086e49ed304001fce9be2',
          createdOn: '2022-08-20T07:01:56.826Z',
          transactionType: 'debit',
          amount: 300,
          balance: 885132.42
        },
        {
          _id: '630086e49ed304001fce9bef',
          teamId: '630086e49ed304001fce9be3',
          createdOn: '2022-08-20T07:01:56.826Z',
          transactionType: 'debit',
          amount: 300,
          balance: 884832.42
        },
        {
          _id: '630086e49ed304001fce9bf0',
          teamId: '630086e49ed304001fce9be4',
          createdOn: '2022-08-20T07:01:56.826Z',
          transactionType: 'debit',
          amount: 300,
          balance: 884532.42
        },
        {
          _id: '630086e49ed304001fce9bf1',
          teamId: '630086e49ed304001fce9be5',
          createdOn: '2022-08-20T07:01:56.826Z',
          transactionType: 'debit',
          amount: 300,
          balance: 884232.42
        },
        {
          _id: '630086e49ed304001fce9bf2',
          teamId: '630086e49ed304001fce9be6',
          createdOn: '2022-08-20T07:01:56.826Z',
          transactionType: 'debit',
          amount: 300,
          balance: 883932.42
        },
        {
          _id: '63010b8c5e725b471e5fd91a',
          teamId: '630086e49ed304001fce9be6',
          transactionType: 'credit',
          balance: 884232.42,
          amount: 300,
          createdOn: '2022-08-20T16:27:55.839Z',
          tax: 0
        },
        {
          _id: '63010b8d5e725b471e5fda3b',
          teamId: '630086e49ed304001fce9be2',
          transactionType: 'credit',
          balance: 884632.42,
          amount: 400,
          createdOn: '2022-08-20T16:27:57.411Z',
          tax: 0
        },
        {
          _id: '63010b8e5e725b471e5fdad3',
          teamId: '630086e49ed304001fce9be1',
          transactionType: 'credit',
          balance: 884932.42,
          amount: 300,
          createdOn: '2022-08-20T16:27:58.296Z',
          tax: 0
        },
        {
          _id: '63010b8f5e725b471e5fdb76',
          teamId: '630086e49ed304001fce9be4',
          transactionType: 'credit',
          balance: 885232.42,
          amount: 300,
          createdOn: '2022-08-20T16:27:59.064Z',
          tax: 0
        }
      ],
      pokerWalletPayment: [],
      bonusWalletPayment: [],
      cashbackWalletPayment: []
    },
    {
      _id: '630086ded344d0001f3096c0',
      entryFee: 3300,
      bonusFee: 0,
      gameId: '62fe51c8d344d0001f307e2c',
      game: 'fantasyCricket',
      matchTitle: 'ZIM vs IND',
      userId: '5fd32b93eaf661ea51eae8af',
      createdOn: '2022-08-20T07:01:50.254Z',
      modifiedOn: '2022-08-20T16:30:23.338Z',
      primaryWalletPayment: [],
      gameWalletPayment: [
        {
          _id: '630086ded344d0001f3096c6',
          teamId: '630086ded344d0001f3096ba',
          createdOn: '2022-08-20T07:01:50.254Z',
          transactionType: 'debit',
          amount: 3300,
          balance: 902232.42
        },
        {
          _id: '630086ded344d0001f3096c7',
          teamId: '630086ded344d0001f3096bb',
          createdOn: '2022-08-20T07:01:50.254Z',
          transactionType: 'debit',
          amount: 3300,
          balance: 898932.42
        },
        {
          _id: '630086ded344d0001f3096c8',
          teamId: '630086ded344d0001f3096bc',
          createdOn: '2022-08-20T07:01:50.254Z',
          transactionType: 'debit',
          amount: 3300,
          balance: 895632.42
        },
        {
          _id: '630086ded344d0001f3096c9',
          teamId: '630086ded344d0001f3096bd',
          createdOn: '2022-08-20T07:01:50.254Z',
          transactionType: 'debit',
          amount: 3300,
          balance: 892332.42
        },
        {
          _id: '630086ded344d0001f3096ca',
          teamId: '630086ded344d0001f3096be',
          createdOn: '2022-08-20T07:01:50.254Z',
          transactionType: 'debit',
          amount: 3300,
          balance: 889032.42
        },
        {
          _id: '630086ded344d0001f3096cb',
          teamId: '630086ded344d0001f3096bf',
          createdOn: '2022-08-20T07:01:50.254Z',
          transactionType: 'debit',
          amount: 3300,
          balance: 885732.42
        },
        {
          _id: '63010c1d5e725b471e607553',
          teamId: '630086ded344d0001f3096bb',
          transactionType: 'credit',
          balance: 888732.42,
          amount: 3500,
          createdOn: '2022-08-20T16:30:21.075Z',
          tax: 0
        },
        {
          _id: '63010c1e5e725b471e607621',
          teamId: '630086ded344d0001f3096bd',
          transactionType: 'credit',
          balance: 891732.42,
          amount: 3000,
          createdOn: '2022-08-20T16:30:21.832Z',
          tax: 0
        },
        {
          _id: '63010c1e5e725b471e6076e0',
          teamId: '630086ded344d0001f3096bf',
          transactionType: 'credit',
          balance: 895232.42,
          amount: 3500,
          createdOn: '2022-08-20T16:30:22.581Z',
          tax: 0
        },
        {
          _id: '63010c1f5e725b471e6077b1',
          teamId: '630086ded344d0001f3096ba',
          transactionType: 'credit',
          balance: 898232.42,
          amount: 3000,
          createdOn: '2022-08-20T16:30:23.338Z',
          tax: 0
        }
      ],
      pokerWalletPayment: [],
      bonusWalletPayment: [],
      cashbackWalletPayment: []
    },
    {
      _id: '62fe8fbc405a94001d20756f',
      entryFee: 100000,
      bonusFee: 0,
      gameId: '62ee5d09f13303001d8a4cdc',
      game: 'poker',
      userId: '5fd32b93eaf661ea51eae8af',
      createdOn: '2022-08-18T19:15:08.538Z',
      primaryWalletPayment: [],
      gameWalletPayment: [],
      pokerWalletPayment: [
        {
          _id: '62fe8fbc405a94001d207570',
          teamId: '62fe8fbcff5803001ddc4c6e',
          createdOn: '2022-08-18T19:15:08.538Z',
          transactionType: 'debit',
          amount: 100000,
          balance: 864064
        },
        {
          _id: '62fe994ad344d0001f3082dc',
          amount: 119068,
          teamId: '62fe994aff5803001ddcd8e5',
          transactionType: 'credit',
          createdOn: '2022-08-18T19:55:54.660Z',
          balance: 905532
        }
      ],
      bonusWalletPayment: [],
      cashbackWalletPayment: []
    },
    {
      _id: '62f3e20fdcd1b0001d3df428',
      entryFee: 25000,
      bonusFee: 0,
      gameId: '62ee5d6cf13303001d8a574d',
      game: 'poker',
      userId: '5fd32b93eaf661ea51eae8af',
      createdOn: '2022-08-10T16:51:27.149Z',
      primaryWalletPayment: [],
      gameWalletPayment: [],
      pokerWalletPayment: [
        {
          _id: '62f3e20fdcd1b0001d3df429',
          teamId: '62f3e20edd80bb001db0b73d',
          createdOn: '2022-08-10T16:51:27.149Z',
          transactionType: 'debit',
          amount: 25000,
          balance: 938789
        },
        {
          _id: '62f3e469f06510001de35d88',
          amount: 22500,
          teamId: '62f3e469dd80bb001db0e160',
          transactionType: 'credit',
          createdOn: '2022-08-10T17:01:29.634Z',
          balance: 950939
        }
      ],
      bonusWalletPayment: [],
      cashbackWalletPayment: []
    },
    {
      _id: '62f15092dcd1b0001d3dcd11',
      entryFee: 200000,
      bonusFee: 0,
      gameId: '62e8bcb83fdbfc001d970fc2',
      game: 'poker',
      userId: '5fd32b93eaf661ea51eae8af',
      createdOn: '2022-08-08T18:06:09.990Z',
      primaryWalletPayment: [
        {
          _id: '62f15092dcd1b0001d3dcd12',
          teamId: '62f15091f13303001dbca129',
          createdOn: '2022-08-08T18:06:09.990Z',
          transactionType: 'debit',
          amount: 200000,
          balance: 174200
        }
      ],
      gameWalletPayment: [],
      pokerWalletPayment: [
        {
          _id: '62f15425f06510001de33610',
          amount: 180000,
          teamId: '62f15425f13303001dbcebef',
          transactionType: 'credit',
          createdOn: '2022-08-08T18:21:25.906Z',
          balance: 645010
        }
      ],
      bonusWalletPayment: [],
      cashbackWalletPayment: []
    },
    {
      _id: '62ee3e267533c5001ff5ec93',
      entryFee: 4000,
      bonusFee: 0,
      gameId: '62e8f7a83fdbfc001d9a7317',
      game: 'poker',
      userId: '5fd32b93eaf661ea51eae8af',
      createdOn: '2022-08-06T10:10:46.532Z',
      primaryWalletPayment: [
        {
          _id: '62ee3e267533c5001ff5ec94',
          teamId: '62ee3e26a9c0a2001d2aedc0',
          createdOn: '2022-08-06T10:10:46.532Z',
          transactionType: 'debit',
          amount: 4000,
          balance: 509200
        }
      ],
      gameWalletPayment: [
        {
          _id: '631f408a1c4ee5001e1291de',
          teamId: '631f408aef2a3f001d347bc4',
          createdOn: '2022-09-12T14:22:02.506Z',
          transactionType: 'debit',
          amount: 20000,
          balance: 849665.42
        },
        {
          _id: '631f462f1c4ee5001e1291ec',
          teamId: '631f462fef2a3f001d34cac5',
          createdOn: '2022-09-12T14:46:07.870Z',
          transactionType: 'debit',
          amount: 200,
          balance: 849465.42
        }
      ],
      pokerWalletPayment: [
        {
          _id: '62ee406f7533c5001ff5ee5d',
          amount: 3500,
          teamId: '62ee406fa9c0a2001d2b0f12',
          transactionType: 'credit',
          createdOn: '2022-08-06T10:20:31.586Z',
          balance: 413106
        },
        {
          _id: '62f380465c148b001e6edbbf',
          teamId: '62f380466bd34a001f5d41fa',
          createdOn: '2022-08-10T09:54:14.884Z',
          transactionType: 'debit',
          amount: 4000,
          balance: 748689
        },
        {
          _id: '62f3813df06510001de354b1',
          amount: 3300,
          teamId: '62f3813dda6f3b001f435c66',
          transactionType: 'credit',
          createdOn: '2022-08-10T09:58:21.818Z',
          balance: 751989
        },
        {
          _id: '62f3e147f06510001de35d5a',
          teamId: '62f3e147dd80bb001db0a760',
          createdOn: '2022-08-10T16:48:07.930Z',
          transactionType: 'debit',
          amount: 4000,
          balance: 963789
        },
        {
          _id: '62f3e8ab5c148b001e6ee60e',
          amount: 1500,
          teamId: '62f3e8aadd80bb001db13940',
          transactionType: 'credit',
          createdOn: '2022-08-10T17:19:39.250Z',
          balance: 964864
        },
        {
          _id: '631f42fc1c4ee5001e1291e7',
          amount: 19800,
          teamId: '631f42fcef2a3f001d349dfb',
          transactionType: 'credit',
          createdOn: '2022-09-12T14:32:28.241Z',
          balance: 19800
        },
        {
          _id: '631f462f1c4ee5001e1291eb',
          teamId: '631f462fef2a3f001d34cac5',
          createdOn: '2022-09-12T14:46:07.870Z',
          transactionType: 'debit',
          amount: 19800,
          balance: 0
        },
        {
          _id: '631f49a0168fcd001e1262b7',
          amount: 19700,
          teamId: '631f49a0ef2a3f001d34fb6b',
          transactionType: 'credit',
          createdOn: '2022-09-12T15:00:48.356Z',
          balance: 19700
        }
      ],
      bonusWalletPayment: [],
      cashbackWalletPayment: []
    },
    {
      _id: '62eac6be7533c5001ff55cc8',
      entryFee: 76146,
      bonusFee: 0,
      gameId: '62c9605042992c001e847341',
      game: 'poker',
      userId: '5fd32b93eaf661ea51eae8af',
      createdOn: '2022-08-03T19:04:30.252Z',
      primaryWalletPayment: [],
      gameWalletPayment: [
        {
          _id: '62eac6be7533c5001ff55cca',
          teamId: '62eac6bea9c0a2001d08fe7a',
          createdOn: '2022-08-03T19:04:30.252Z',
          transactionType: 'debit',
          amount: 27658.239999999998,
          balance: 0.42000000000552973
        }
      ],
      pokerWalletPayment: [
        {
          _id: '62eac6be7533c5001ff55cc9',
          teamId: '62eac6bea9c0a2001d08fe7a',
          createdOn: '2022-08-03T19:04:30.252Z',
          transactionType: 'debit',
          amount: 48487.76,
          balance: 0
        },
        {
          _id: '62ead04d7533c5001ff55cd6',
          amount: 81746,
          teamId: '62ead04ca9c0a2001d0905e1',
          transactionType: 'credit',
          createdOn: '2022-08-03T19:45:17.081Z',
          balance: 81746
        }
      ],
      bonusWalletPayment: [],
      cashbackWalletPayment: []
    },
    {
      _id: '62ea58f67533c5001ff545fb',
      entryFee: 2000,
      bonusFee: 0,
      gameId: '624efb8f0fe966001dbc6250',
      game: 'poker',
      userId: '5fd32b93eaf661ea51eae8af',
      createdOn: '2022-08-03T11:16:06.670Z',
      primaryWalletPayment: [],
      gameWalletPayment: [],
      pokerWalletPayment: [
        {
          _id: '62ea58f67533c5001ff545fc',
          teamId: '62ea58f6a9c0a2001d023f3f',
          createdOn: '2022-08-03T11:16:06.670Z',
          transactionType: 'debit',
          amount: 2000,
          balance: 45048
        },
        {
          _id: '62ea5b12c0c772001d75cbd6',
          amount: 5760,
          teamId: '62ea5b12a9c0a2001d025956',
          transactionType: 'credit',
          createdOn: '2022-08-03T11:25:06.587Z',
          balance: 51487.76
        }
      ],
      bonusWalletPayment: [],
      cashbackWalletPayment: []
    },
    {
      _id: '62ea47097533c5001ff54517',
      entryFee: 10000,
      bonusFee: 0,
      gameId: '61ef9b31cf849e001eba74f1',
      game: 'poker',
      userId: '5fd32b93eaf661ea51eae8af',
      createdOn: '2022-08-03T09:59:37.771Z',
      primaryWalletPayment: [
        {
          _id: '62ef79dff06510001de31702',
          teamId: '62ef79dff13303001d99969d',
          createdOn: '2022-08-07T08:37:51.538Z',
          transactionType: 'debit',
          amount: 10000,
          balance: 499200
        },
        {
          _id: '62f28b515c148b001e6ecb41',
          teamId: '62f28b50f13303001dc9eb33',
          createdOn: '2022-08-09T16:29:05.058Z',
          transactionType: 'debit',
          amount: 10000,
          balance: 164200
        }
      ],
      gameWalletPayment: [],
      pokerWalletPayment: [
        {
          _id: '62ea47097533c5001ff54518',
          teamId: '62ea4709a9c0a2001d01647b',
          createdOn: '2022-08-03T09:59:37.771Z',
          transactionType: 'debit',
          amount: 10000,
          balance: 39890
        },
        {
          _id: '62ea491a0056ce001fc2c78b',
          amount: 10000,
          teamId: '62ea491aa9c0a2001d01760d',
          transactionType: 'credit',
          createdOn: '2022-08-03T10:08:26.559Z',
          balance: 47890
        },
        {
          _id: '62ebaea10056ce001fc2e892',
          teamId: '62ebaea1a9c0a2001d0fcad2',
          createdOn: '2022-08-04T11:33:53.381Z',
          transactionType: 'debit',
          amount: 10000,
          balance: 71746
        },
        {
          _id: '62ebbd060056ce001fc2e94b',
          amount: 10832,
          teamId: '62ebbd05a9c0a2001d10b933',
          transactionType: 'credit',
          createdOn: '2022-08-04T12:35:18.062Z',
          balance: 82578
        },
        {
          _id: '62ef7f0ff06510001de31840',
          amount: 11904,
          teamId: '62ef7f0ff13303001d99e925',
          transactionType: 'credit',
          createdOn: '2022-08-07T08:59:59.947Z',
          balance: 425010
        },
        {
          _id: '62f2918edcd1b0001d3ddcaf',
          amount: 6784,
          teamId: '62f2918ef13303001dca680b',
          transactionType: 'credit',
          createdOn: '2022-08-09T16:55:42.543Z',
          balance: 699954
        },
        {
          _id: '62f383785c148b001e6edbe8',
          teamId: '62f38377da6f3b001f43ae4c',
          createdOn: '2022-08-10T10:07:52.033Z',
          transactionType: 'debit',
          amount: 10000,
          balance: 741989
        },
        {
          _id: '62f38447f06510001de354c4',
          amount: 10000,
          teamId: '62f38446dd80bb001daa82bb',
          transactionType: 'credit',
          createdOn: '2022-08-10T10:11:19.067Z',
          balance: 751989
        },
        {
          _id: '62f3e21cdcd1b0001d3df42d',
          teamId: '62f3e21cdd80bb001db0b844',
          createdOn: '2022-08-10T16:51:40.424Z',
          transactionType: 'debit',
          amount: 10000,
          balance: 926789
        },
        {
          _id: '62f3e487dcd1b0001d3df465',
          amount: 11656,
          teamId: '62f3e486dd80bb001db0e3fa',
          transactionType: 'credit',
          createdOn: '2022-08-10T17:01:59.008Z',
          balance: 962595
        }
      ],
      bonusWalletPayment: [],
      cashbackWalletPayment: []
    },
    {
      _id: '62e96a2e7533c5001ff53adb',
      entryFee: 10000,
      bonusFee: 0,
      gameId: '61f95b171e252c001ef9784e',
      game: 'poker',
      userId: '5fd32b93eaf661ea51eae8af',
      createdOn: '2022-08-02T18:17:18.670Z',
      primaryWalletPayment: [],
      gameWalletPayment: [],
      pokerWalletPayment: [
        {
          _id: '62e96a2e7533c5001ff53adc',
          teamId: '62e96a2e3fdbfc001da33ce4',
          createdOn: '2022-08-02T18:17:18.670Z',
          transactionType: 'debit',
          amount: 10000,
          balance: 39940
        },
        {
          _id: '62e96a34c0c772001d75c121',
          amount: 10000,
          teamId: '62e96a333fdbfc001da33d7d',
          transactionType: 'credit',
          createdOn: '2022-08-02T18:17:24.062Z',
          balance: 49940
        }
      ],
      bonusWalletPayment: [],
      cashbackWalletPayment: []
    },
    {
      _id: '62e96955c0c772001d75c098',
      entryFee: 50000,
      bonusFee: 0,
      gameId: '62e685bc3fdbfc001d89d7bd',
      game: 'poker',
      userId: '5fd32b93eaf661ea51eae8af',
      createdOn: '2022-08-02T18:13:41.584Z',
      primaryWalletPayment: [
        {
          _id: '62ed31990056ce001fc30ed4',
          teamId: '62ed3198a9c0a2001d222af2',
          createdOn: '2022-08-05T15:04:57.077Z',
          transactionType: 'debit',
          amount: 150000,
          balance: 674200
        },
        {
          _id: '62ed34617533c5001ff58c63',
          teamId: '62ed3460a9c0a2001d226657',
          createdOn: '2022-08-05T15:16:49.128Z',
          transactionType: 'debit',
          amount: 50000,
          balance: 624200
        },
        {
          _id: '62ed39087533c5001ff58d9b',
          teamId: '62ed3908a9c0a2001d22c8f1',
          createdOn: '2022-08-05T15:36:40.943Z',
          transactionType: 'debit',
          amount: 111000,
          balance: 513200
        },
        {
          _id: '62f1495af06510001de334e5',
          teamId: '62f14959f13303001dbbdcb6',
          createdOn: '2022-08-08T17:35:22.119Z',
          transactionType: 'debit',
          amount: 50000,
          balance: 449200
        },
        {
          _id: '62f14a65dcd1b0001d3dcbf8',
          teamId: '62f14a64f13303001dbbf739',
          createdOn: '2022-08-08T17:39:49.093Z',
          transactionType: 'debit',
          amount: 25000,
          balance: 424200
        },
        {
          _id: '62f150815c148b001e6ebd4a',
          teamId: '62f15081f13303001dbc9fc5',
          createdOn: '2022-08-08T18:05:53.387Z',
          transactionType: 'debit',
          amount: 50000,
          balance: 374200
        }
      ],
      gameWalletPayment: [],
      pokerWalletPayment: [
        {
          _id: '62e96955c0c772001d75c099',
          teamId: '62e969553fdbfc001da3281b',
          createdOn: '2022-08-02T18:13:41.584Z',
          transactionType: 'debit',
          amount: 50000,
          balance: 0
        },
        {
          _id: '62e9698a0056ce001fc2bdaf',
          amount: 49000,
          teamId: '62e9698a3fdbfc001da32c9c',
          transactionType: 'credit',
          createdOn: '2022-08-02T18:14:34.910Z',
          balance: 49000
        },
        {
          _id: '62ed42177533c5001ff59114',
          amount: 144200,
          teamId: '62ed4217a9c0a2001d237593',
          transactionType: 'credit',
          createdOn: '2022-08-05T16:15:19.496Z',
          balance: 409606
        },
        {
          _id: '62f14e8fdcd1b0001d3dcd09',
          amount: 40000,
          teamId: '62f14e8ff13303001dbc6855',
          transactionType: 'credit',
          createdOn: '2022-08-08T17:57:35.776Z',
          balance: 465010
        },
        {
          _id: '62f159b15c148b001e6ebd58',
          amount: 48160,
          teamId: '62f159b1f13303001dbd5a5a',
          transactionType: 'credit',
          createdOn: '2022-08-08T18:45:05.798Z',
          balance: 693170
        }
      ],
      bonusWalletPayment: [],
      cashbackWalletPayment: []
    },
    {
      _id: '62e9691a0056ce001fc2bd60',
      entryFee: 50000,
      bonusFee: 0,
      gameId: '62e6bbc73fdbfc001d8c2884',
      game: 'poker',
      userId: '5fd32b93eaf661ea51eae8af',
      createdOn: '2022-08-02T18:12:42.214Z',
      primaryWalletPayment: [],
      gameWalletPayment: [
        {
          _id: '62e9691a0056ce001fc2bd62',
          teamId: '62e969193fdbfc001da322dc',
          createdOn: '2022-08-02T18:12:42.214Z',
          transactionType: 'debit',
          amount: 356,
          balance: 28658.660000000003
        }
      ],
      pokerWalletPayment: [
        {
          _id: '62e9691a0056ce001fc2bd61',
          teamId: '62e969193fdbfc001da322dc',
          createdOn: '2022-08-02T18:12:42.214Z',
          transactionType: 'debit',
          amount: 49644,
          balance: 0
        },
        {
          _id: '62e9692dc0c772001d75c097',
          amount: 50000,
          teamId: '62e9692d3fdbfc001da32424',
          transactionType: 'credit',
          createdOn: '2022-08-02T18:13:01.859Z',
          balance: 50000
        }
      ],
      bonusWalletPayment: [],
      cashbackWalletPayment: []
    },
    {
      _id: '62e8fa307533c5001ff52158',
      entryFee: 10000,
      bonusFee: 0,
      gameId: '624efa2c0fe966001dbc5dd1',
      game: 'poker',
      userId: '5fd32b93eaf661ea51eae8af',
      createdOn: '2022-08-02T10:19:28.549Z',
      primaryWalletPayment: [],
      gameWalletPayment: [],
      pokerWalletPayment: [
        {
          _id: '62e8fa307533c5001ff52159',
          teamId: '62e8fa303fdbfc001d9a988e',
          createdOn: '2022-08-02T10:19:28.549Z',
          transactionType: 'debit',
          amount: 10000,
          balance: 38619
        },
        {
          _id: '62e901437533c5001ff5235a',
          amount: 10000,
          teamId: '62e901433fdbfc001d9b031f',
          transactionType: 'credit',
          createdOn: '2022-08-02T10:49:39.215Z',
          balance: 49644
        },
        {
          _id: '62e9014fc0c772001d75ab21',
          teamId: '62e9014f3fdbfc001d9b041e',
          createdOn: '2022-08-02T10:49:51.492Z',
          transactionType: 'debit',
          amount: 2000,
          balance: 47644
        },
        {
          _id: '62e901547533c5001ff52399',
          teamId: '62e901533fdbfc001d9b0469',
          createdOn: '2022-08-02T10:49:56.037Z',
          transactionType: 'debit',
          amount: 8000,
          balance: 39644
        },
        {
          _id: '62e9085e7533c5001ff527d0',
          amount: 10000,
          teamId: '62e9085e3fdbfc001d9b6a5d',
          transactionType: 'credit',
          createdOn: '2022-08-02T11:19:58.962Z',
          balance: 49644
        },
        {
          _id: '62ea57e60056ce001fc2c804',
          teamId: '62ea57e6a9c0a2001d022cc0',
          createdOn: '2022-08-03T11:11:34.777Z',
          transactionType: 'debit',
          amount: 2000,
          balance: 49048
        },
        {
          _id: '62ea58457533c5001ff545f7',
          teamId: '62ea5845a9c0a2001d0233ce',
          createdOn: '2022-08-03T11:13:09.432Z',
          transactionType: 'debit',
          amount: 2000,
          balance: 47048
        },
        {
          _id: '62ea5aeac0c772001d75cbd5',
          amount: 679.7599999999999,
          teamId: '62ea5aeaa9c0a2001d0256f4',
          transactionType: 'credit',
          createdOn: '2022-08-03T11:24:26.557Z',
          balance: 45727.76
        }
      ],
      bonusWalletPayment: [],
      cashbackWalletPayment: []
    },
    {
      _id: '62e8c9bbc0c772001d75a199',
      entryFee: 25000,
      bonusFee: 0,
      gameId: '61ef9aedcf849e001eba74a9',
      game: 'poker',
      userId: '5fd32b93eaf661ea51eae8af',
      createdOn: '2022-08-02T06:52:43.187Z',
      primaryWalletPayment: [
        {
          _id: '62ed220c7533c5001ff582e7',
          teamId: '62ed220ca9c0a2001d20eccf',
          createdOn: '2022-08-05T13:58:36.847Z',
          transactionType: 'debit',
          amount: 25000,
          balance: 915000
        },
        {
          _id: '62f294875c148b001e6ecd1b',
          teamId: '62f29487f13303001dcaa6ba',
          createdOn: '2022-08-09T17:08:23.794Z',
          transactionType: 'debit',
          amount: 18300,
          balance: 0
        }
      ],
      gameWalletPayment: [],
      pokerWalletPayment: [
        {
          _id: '62e8c9bbc0c772001d75a19a',
          teamId: '62e8c9ba3fdbfc001d97c335',
          createdOn: '2022-08-02T06:52:43.187Z',
          transactionType: 'debit',
          amount: 25000,
          balance: 28149
        },
        {
          _id: '62e8cdda0056ce001fc29ebe',
          amount: 23500,
          teamId: '62e8cdda3fdbfc001d97ffea',
          transactionType: 'credit',
          createdOn: '2022-08-02T07:10:18.787Z',
          balance: 51649
        },
        {
          _id: '62e8ce70c0c772001d75a1f0',
          teamId: '62e8ce6f3fdbfc001d9807e8',
          createdOn: '2022-08-02T07:12:48.152Z',
          transactionType: 'debit',
          amount: 25000,
          balance: 26649
        },
        {
          _id: '62e8d0820056ce001fc29ed6',
          amount: 24500,
          teamId: '62e8d0823fdbfc001d9827bd',
          transactionType: 'credit',
          createdOn: '2022-08-02T07:21:38.914Z',
          balance: 51149
        },
        {
          _id: '62e8d11b0056ce001fc29ee9',
          teamId: '62e8d11a3fdbfc001d9830c2',
          createdOn: '2022-08-02T07:24:11.196Z',
          transactionType: 'debit',
          amount: 25000,
          balance: 26149
        },
        {
          _id: '62e8d30c7533c5001ff51aa2',
          amount: 25000,
          teamId: '62e8d30c3fdbfc001d985074',
          transactionType: 'credit',
          createdOn: '2022-08-02T07:32:28.842Z',
          balance: 51149
        },
        {
          _id: '62e96a127533c5001ff53ada',
          teamId: '62e96a123fdbfc001da339e4',
          createdOn: '2022-08-02T18:16:50.969Z',
          transactionType: 'debit',
          amount: 25000,
          balance: 24940
        },
        {
          _id: '62e96a1b0056ce001fc2bdf5',
          amount: 25000,
          teamId: '62e96a1b3fdbfc001da33b70',
          transactionType: 'credit',
          createdOn: '2022-08-02T18:16:59.249Z',
          balance: 49940
        },
        {
          _id: '62ea8de87533c5001ff54ada',
          teamId: '62ea8de8a9c0a2001d056c22',
          createdOn: '2022-08-03T15:02:00.800Z',
          transactionType: 'debit',
          amount: 25000,
          balance: 26487.760000000002
        },
        {
          _id: '62ea901e7533c5001ff54b2a',
          amount: 22000,
          teamId: '62ea901ea9c0a2001d059d55',
          transactionType: 'credit',
          createdOn: '2022-08-03T15:11:26.768Z',
          balance: 48487.76
        },
        {
          _id: '62ed2be8c0c772001d760d51',
          amount: 10848,
          teamId: '62ed2be7a9c0a2001d21b1b5',
          transactionType: 'credit',
          createdOn: '2022-08-05T14:40:40.011Z',
          balance: 53426
        },
        {
          _id: '62f294875c148b001e6ecd1c',
          teamId: '62f29487f13303001dcaa6ba',
          createdOn: '2022-08-09T17:08:23.794Z',
          transactionType: 'debit',
          amount: 6700,
          balance: 789154
        },
        {
          _id: '62f2984bdcd1b0001d3ddf9b',
          teamId: '62f2984bf13303001dcaef64',
          createdOn: '2022-08-09T17:24:27.656Z',
          transactionType: 'debit',
          amount: 25000,
          balance: 764154
        },
        {
          _id: '62f29cb35c148b001e6ed19c',
          teamId: '62f29cb2f13303001dcb49e2',
          createdOn: '2022-08-09T17:43:15.053Z',
          transactionType: 'debit',
          amount: 25000,
          balance: 739154
        },
        {
          _id: '62f29f105c148b001e6ed29f',
          amount: 36000,
          teamId: '62f29f10f13303001dcb76c5',
          transactionType: 'credit',
          createdOn: '2022-08-09T17:53:20.281Z',
          balance: 775154
        },
        {
          _id: '62f3652fdcd1b0001d3de9d6',
          teamId: '62f3652ff13303001dd44c2b',
          createdOn: '2022-08-10T07:58:39.652Z',
          transactionType: 'debit',
          amount: 25000,
          balance: 748154
        },
        {
          _id: '62f36c44f06510001de353c5',
          teamId: '62f36c44f13303001dd4a44b',
          createdOn: '2022-08-10T08:28:52.294Z',
          transactionType: 'debit',
          amount: 42692,
          balance: 705462
        },
        {
          _id: '62f371655c148b001e6edaf7',
          amount: 47227,
          teamId: '62f37165f13303001dd4e474',
          transactionType: 'credit',
          createdOn: '2022-08-10T08:50:45.633Z',
          balance: 752689
        },
        {
          _id: '62f396e1f06510001de35528',
          teamId: '62f396e0dd80bb001dab13eb',
          createdOn: '2022-08-10T11:30:41.014Z',
          transactionType: 'debit',
          amount: 100000,
          balance: 651989
        },
        {
          _id: '62f399c25c148b001e6edcac',
          amount: 316200,
          teamId: '62f399c1dd80bb001dab37ac',
          transactionType: 'credit',
          createdOn: '2022-08-10T11:42:58.047Z',
          balance: 968189
        }
      ],
      bonusWalletPayment: [],
      cashbackWalletPayment: []
    }
  ],
  count: 147
};

export const transactionWithdrawAdjustments = [
  {
    _id: '61de7cdd1f6669001ef06758',
    userId: '601cd58656c4dd5b565191e9',
    amount: 530576,
    transactionType: 'credit',
    transfer: true,
    balance: 575956,
    createdOn: '2022-01-12T07:01:49.055Z'
  },
  {
    _id: '615b03e755d7e30021473119',
    transactionType: 'credit',
    userId: '601cd58656c4dd5b565191e9',
    amount: 5000,
    balance: 5000,
    createdOn: '2021-10-04T13:38:47.701Z',
    modifiedOn: '2021-10-04T13:38:47.701Z',
    comment: 'Testing',
    modifiedBy: '5fcfa2fe6d6b0312af1607a6'
  },
  {
    _id: '60aecc27a537d2521b657daf',
    amount: 0,
    userId: '601cd58656c4dd5b565191e9',
    balance: 0,
    createdOn: '2001-05-26T22:41:17.906Z',
    transactionType: 'credit'
  }
];
export const transactionPoker = {
  result: [
    {
      _id: '61ff9b90670a6a0021b97a47',
      entryFee: 25000,
      bonusFee: 0,
      gameId: '61af080b4832e5002425e3e9',
      game: 'poker',
      userId: '601cd58656c4dd5b565191e9',
      createdOn: '2022-02-06T09:57:36.319Z',
      primaryWalletPayment: [
        {
          _id: '61ff9b90670a6a0021b97a48',
          teamId: '61ff9b904479ad0025acdcdf',
          createdOn: '2022-02-06T09:57:36.319Z',
          transactionType: 'debit',
          amount: 25000,
          balance: 1572100
        }
      ],
      gameWalletPayment: [],
      pokerWalletPayment: [
        {
          _id: '61ff9b93670a6a0021b97a49',
          amount: 25000,
          teamId: '61ff9b934479ad0025acdcec',
          transactionType: 'credit',
          balance: 924809.2
        }
      ],
      bonusWalletPayment: [],
      cashbackWalletPayment: []
    },
    {
      _id: '61fec153670a6a0021b97979',
      entryFee: 25000,
      bonusFee: 0,
      gameId: '619e1dcd60f1a7002a3f015d',
      game: 'poker',
      userId: '601cd58656c4dd5b565191e9',
      createdOn: '2022-02-05T18:26:27.913Z',
      primaryWalletPayment: [
        {
          _id: '61fec153670a6a0021b9797a',
          teamId: '61fec1534479ad0025ac829c',
          createdOn: '2022-02-05T18:26:27.913Z',
          transactionType: 'debit',
          amount: 25000,
          balance: 1995900
        },
        {
          _id: '61ff9bab670a6a0021b97a51',
          teamId: '61ff9baa4479ad0025acdd6e',
          createdOn: '2022-02-06T09:58:02.993Z',
          transactionType: 'debit',
          amount: 25000,
          balance: 1497100
        },
        {
          _id: '61ff9ef1670a6a0021b97a7a',
          teamId: '61ff9ef14479ad0025ace119',
          createdOn: '2022-02-06T10:12:01.211Z',
          transactionType: 'debit',
          amount: 25000,
          balance: 1300800
        },
        {
          _id: '61ff9f77670a6a0021b97aa0',
          teamId: '61ff9f774479ad0025ace385',
          createdOn: '2022-02-06T10:14:15.284Z',
          transactionType: 'debit',
          amount: 25000,
          balance: 1104900
        }
      ],
      gameWalletPayment: [],
      pokerWalletPayment: [
        {
          _id: '61fec156670a6a0021b9797b',
          amount: 25000,
          teamId: '61fec1564479ad0025ac82aa',
          transactionType: 'credit',
          balance: 476009.2
        },
        {
          _id: '61ff9bad670a6a0021b97a52',
          amount: 25000,
          teamId: '61ff9bad4479ad0025acdd7d',
          transactionType: 'credit',
          balance: 999809.2
        },
        {
          _id: '61ff9efb670a6a0021b97a7d',
          amount: 25000,
          teamId: '61ff9efb4479ad0025ace140',
          transactionType: 'credit',
          balance: 1171109.2
        },
        {
          _id: '61ff9f82670a6a0021b97aa3',
          amount: 25000,
          teamId: '61ff9f824479ad0025ace3bb',
          transactionType: 'credit',
          balance: 1392009.2
        }
      ],
      bonusWalletPayment: [],
      cashbackWalletPayment: []
    },
    {
      _id: '61fec001670a6a0021b97963',
      entryFee: 25000,
      bonusFee: 0,
      gameId: '619e1e0a60f1a7002a3f015e',
      game: 'poker',
      userId: '601cd58656c4dd5b565191e9',
      createdOn: '2022-02-05T18:20:49.425Z',
      primaryWalletPayment: [
        {
          _id: '61fec001670a6a0021b97964',
          teamId: '61fec0014479ad0025ac80f1',
          createdOn: '2022-02-05T18:20:49.425Z',
          transactionType: 'debit',
          amount: 25000,
          balance: 2163800
        },
        {
          _id: '61fec145670a6a0021b97976',
          teamId: '61fec1454479ad0025ac8257',
          createdOn: '2022-02-05T18:26:13.399Z',
          transactionType: 'debit',
          amount: 25000,
          balance: 2020900
        },
        {
          _id: '61fec277670a6a0021b979a6',
          teamId: '61fec2774479ad0025ac85ac',
          createdOn: '2022-02-05T18:31:19.200Z',
          transactionType: 'debit',
          amount: 25000,
          balance: 1796100
        },
        {
          _id: '61ff9ba2670a6a0021b97a4e',
          teamId: '61ff9ba24479ad0025acdd42',
          createdOn: '2022-02-06T09:57:54.478Z',
          transactionType: 'debit',
          amount: 25000,
          balance: 1522100
        },
        {
          _id: '61ff9f1b670a6a0021b97a88',
          teamId: '61ff9f1a4479ad0025ace1ec',
          createdOn: '2022-02-06T10:12:43.052Z',
          transactionType: 'debit',
          amount: 25000,
          balance: 1215800
        }
      ],
      gameWalletPayment: [],
      pokerWalletPayment: [
        {
          _id: '61fec004670a6a0021b97965',
          amount: 25000,
          teamId: '61fec0044479ad0025ac8100',
          transactionType: 'credit',
          balance: 358109.2
        },
        {
          _id: '61fec16d670a6a0021b97983',
          amount: 25000,
          teamId: '61fec16d4479ad0025ac832a',
          transactionType: 'credit',
          balance: 503009.2
        },
        {
          _id: '61fec27f670a6a0021b979a8',
          amount: 25000,
          teamId: '61fec27e4479ad0025ac85cd',
          transactionType: 'credit',
          balance: 675809.2
        },
        {
          _id: '61ff9ba5670a6a0021b97a4f',
          amount: 25000,
          teamId: '61ff9ba54479ad0025acdd51',
          transactionType: 'credit',
          balance: 974809.2
        },
        {
          _id: '61ff9f23670a6a0021b97a8a',
          amount: 25000,
          teamId: '61ff9f234479ad0025ace20e',
          transactionType: 'credit',
          balance: 1256109.2
        }
      ],
      bonusWalletPayment: [],
      cashbackWalletPayment: []
    },
    {
      _id: '61febfed670a6a0021b97960',
      entryFee: 25000,
      bonusFee: 0,
      gameId: '61a9f6428092530028d6522b',
      game: 'poker',
      userId: '601cd58656c4dd5b565191e9',
      createdOn: '2022-02-05T18:20:29.656Z',
      primaryWalletPayment: [
        {
          _id: '61febfed670a6a0021b97961',
          teamId: '61febfed4479ad0025ac80be',
          createdOn: '2022-02-05T18:20:29.656Z',
          transactionType: 'debit',
          amount: 25000,
          balance: 2188800
        },
        {
          _id: '61fec13a670a6a0021b97973',
          teamId: '61fec13a4479ad0025ac822b',
          createdOn: '2022-02-05T18:26:02.210Z',
          transactionType: 'debit',
          amount: 25000,
          balance: 2045900
        },
        {
          _id: '61ff9b98670a6a0021b97a4b',
          teamId: '61ff9b984479ad0025acdd10',
          createdOn: '2022-02-06T09:57:44.833Z',
          transactionType: 'debit',
          amount: 25000,
          balance: 1547100
        },
        {
          _id: '61ff9ee9670a6a0021b97a77',
          teamId: '61ff9ee94479ad0025ace0ea',
          createdOn: '2022-02-06T10:11:53.825Z',
          transactionType: 'debit',
          amount: 25000,
          balance: 1325800
        },
        {
          _id: '61ff9f72670a6a0021b97a9e',
          teamId: '61ff9f724479ad0025ace368',
          createdOn: '2022-02-06T10:14:10.382Z',
          transactionType: 'debit',
          amount: 25000,
          balance: 1129900
        }
      ],
      gameWalletPayment: [],
      pokerWalletPayment: [
        {
          _id: '61febff1670a6a0021b97962',
          amount: 25000,
          teamId: '61febff14479ad0025ac80cb',
          transactionType: 'credit',
          balance: 333109.2
        },
        {
          _id: '61fec14d670a6a0021b97978',
          amount: 25000,
          teamId: '61fec14d4479ad0025ac8278',
          transactionType: 'credit',
          balance: 451009.2
        },
        {
          _id: '61ff9b9b670a6a0021b97a4c',
          amount: 25000,
          teamId: '61ff9b9b4479ad0025acdd1d',
          transactionType: 'credit',
          balance: 949809.2
        },
        {
          _id: '61ff9eed670a6a0021b97a78',
          amount: 25000,
          teamId: '61ff9eec4479ad0025ace0f9',
          transactionType: 'credit',
          balance: 1146109.2
        },
        {
          _id: '61ff9f7b670a6a0021b97aa1',
          amount: 25000,
          teamId: '61ff9f7b4479ad0025ace393',
          transactionType: 'credit',
          balance: 1342009.2
        }
      ],
      bonusWalletPayment: [],
      cashbackWalletPayment: []
    },
    {
      _id: '61febfdd670a6a0021b9795a',
      entryFee: 25000,
      bonusFee: 0,
      gameId: '61af08ce4832e5002425e50e',
      game: 'poker',
      userId: '601cd58656c4dd5b565191e9',
      createdOn: '2022-02-05T18:20:13.145Z',
      primaryWalletPayment: [
        {
          _id: '61febfdd670a6a0021b9795b',
          teamId: '61febfdc4479ad0025ac8063',
          createdOn: '2022-02-05T18:20:13.145Z',
          transactionType: 'debit',
          amount: 25000,
          balance: 2238800
        },
        {
          _id: '61febfe5670a6a0021b9795e',
          teamId: '61febfe44479ad0025ac808e',
          createdOn: '2022-02-05T18:20:21.183Z',
          transactionType: 'debit',
          amount: 25000,
          balance: 2213800
        },
        {
          _id: '61fec271670a6a0021b979a4',
          teamId: '61fec2714479ad0025ac8593',
          createdOn: '2022-02-05T18:31:13.826Z',
          transactionType: 'debit',
          amount: 25000,
          balance: 1821100
        },
        {
          _id: '61ff9b80670a6a0021b97a42',
          teamId: '61ff9b7f4479ad0025acdc86',
          createdOn: '2022-02-06T09:57:20.036Z',
          transactionType: 'debit',
          amount: 25000,
          balance: 1622100
        },
        {
          _id: '61ff9b88670a6a0021b97a45',
          teamId: '61ff9b884479ad0025acdcb2',
          createdOn: '2022-02-06T09:57:28.669Z',
          transactionType: 'debit',
          amount: 25000,
          balance: 1597100
        },
        {
          _id: '61ff9f16670a6a0021b97a86',
          teamId: '61ff9f164479ad0025ace1d4',
          createdOn: '2022-02-06T10:12:38.185Z',
          transactionType: 'debit',
          amount: 25000,
          balance: 1240800
        }
      ],
      gameWalletPayment: [],
      pokerWalletPayment: [
        {
          _id: '61febfe0670a6a0021b9795c',
          amount: 25000,
          teamId: '61febfe04479ad0025ac8071',
          transactionType: 'credit',
          balance: 283109.2
        },
        {
          _id: '61febfe7670a6a0021b9795f',
          amount: 25000,
          teamId: '61febfe64479ad0025ac809c',
          transactionType: 'credit',
          balance: 308109.2
        },
        {
          _id: '61fec27a670a6a0021b979a7',
          amount: 25000,
          teamId: '61fec27a4479ad0025ac85ba',
          transactionType: 'credit',
          balance: 650809.2
        },
        {
          _id: '61ff9b83670a6a0021b97a43',
          amount: 25000,
          teamId: '61ff9b834479ad0025acdc94',
          transactionType: 'credit',
          balance: 874809.2
        },
        {
          _id: '61ff9b8b670a6a0021b97a46',
          amount: 25000,
          teamId: '61ff9b8b4479ad0025acdcbf',
          transactionType: 'credit',
          balance: 899809.2
        },
        {
          _id: '61ff9f26670a6a0021b97a8b',
          amount: 25000,
          teamId: '61ff9f264479ad0025ace225',
          transactionType: 'credit',
          balance: 1281109.2
        }
      ],
      bonusWalletPayment: [],
      cashbackWalletPayment: []
    },
    {
      _id: '61febfd3670a6a0021b97957',
      entryFee: 25000,
      bonusFee: 0,
      gameId: '61b05010ae65bd0024bfab59',
      game: 'poker',
      userId: '601cd58656c4dd5b565191e9',
      createdOn: '2022-02-05T18:20:03.949Z',
      primaryWalletPayment: [
        {
          _id: '61febfd3670a6a0021b97958',
          teamId: '61febfd34479ad0025ac8033',
          createdOn: '2022-02-05T18:20:03.949Z',
          transactionType: 'debit',
          amount: 25000,
          balance: 2263800
        },
        {
          _id: '61fec263670a6a0021b979a0',
          teamId: '61fec2634479ad0025ac854d',
          createdOn: '2022-02-05T18:30:59.825Z',
          transactionType: 'debit',
          amount: 25000,
          balance: 1846100
        },
        {
          _id: '61ff9b78670a6a0021b97a3f',
          teamId: '61ff9b784479ad0025acdc58',
          createdOn: '2022-02-06T09:57:12.947Z',
          transactionType: 'debit',
          amount: 25000,
          balance: 1647100
        }
      ],
      gameWalletPayment: [],
      pokerWalletPayment: [
        {
          _id: '61febfd6670a6a0021b97959',
          amount: 25000,
          teamId: '61febfd64479ad0025ac8041',
          transactionType: 'credit',
          balance: 258109.2
        },
        {
          _id: '61fec26a670a6a0021b979a1',
          amount: 25000,
          teamId: '61fec26a4479ad0025ac855c',
          transactionType: 'credit',
          balance: 600809.2
        },
        {
          _id: '61ff9b7b670a6a0021b97a40',
          amount: 25000,
          teamId: '61ff9b7a4479ad0025acdc66',
          transactionType: 'credit',
          balance: 849809.2
        }
      ],
      bonusWalletPayment: [],
      cashbackWalletPayment: []
    },
    {
      _id: '61febfce670a6a0021b97954',
      entryFee: 25000,
      bonusFee: 0,
      gameId: '61b0502dae65bd0024bfab7b',
      game: 'poker',
      userId: '601cd58656c4dd5b565191e9',
      createdOn: '2022-02-05T18:19:58.358Z',
      primaryWalletPayment: [
        {
          _id: '61febfce670a6a0021b97955',
          teamId: '61febfce4479ad0025ac8003',
          createdOn: '2022-02-05T18:19:58.358Z',
          transactionType: 'debit',
          amount: 25000,
          balance: 2288800
        },
        {
          _id: '61fec254670a6a0021b9799c',
          teamId: '61fec2534479ad0025ac8504',
          createdOn: '2022-02-05T18:30:44.056Z',
          transactionType: 'debit',
          amount: 25000,
          balance: 1871100
        },
        {
          _id: '61ff9b71670a6a0021b97a3c',
          teamId: '61ff9b714479ad0025acdc25',
          createdOn: '2022-02-06T09:57:05.558Z',
          transactionType: 'debit',
          amount: 25000,
          balance: 1672100
        }
      ],
      gameWalletPayment: [],
      pokerWalletPayment: [
        {
          _id: '61febfd0670a6a0021b97956',
          amount: 25000,
          teamId: '61febfd04479ad0025ac8010',
          transactionType: 'credit',
          balance: 233109.2
        },
        {
          _id: '61fec25c670a6a0021b9799d',
          amount: 25000,
          teamId: '61fec25c4479ad0025ac8514',
          transactionType: 'credit',
          balance: 550809.2
        },
        {
          _id: '61ff9b73670a6a0021b97a3d',
          amount: 25000,
          teamId: '61ff9b734479ad0025acdc32',
          transactionType: 'credit',
          balance: 824809.2
        }
      ],
      bonusWalletPayment: [],
      cashbackWalletPayment: []
    },
    {
      _id: '61febfa2670a6a0021b97942',
      entryFee: 5000,
      bonusFee: 0,
      gameId: '61bc4325f75e400024834fbc',
      game: 'poker',
      userId: '601cd58656c4dd5b565191e9',
      createdOn: '2022-02-05T18:19:14.431Z',
      primaryWalletPayment: [
        {
          _id: '61febfa2670a6a0021b97943',
          teamId: '61febfa24479ad0025ac7edf',
          createdOn: '2022-02-05T18:19:14.431Z',
          transactionType: 'debit',
          amount: 5000,
          balance: 2398800
        },
        {
          _id: '61fec11b670a6a0021b97967',
          teamId: '61fec11b4479ad0025ac8184',
          createdOn: '2022-02-05T18:25:31.322Z',
          transactionType: 'debit',
          amount: 12900,
          balance: 2150900
        },
        {
          _id: '61ff9b37670a6a0021b97a2a',
          teamId: '61ff9b374479ad0025acdaf9',
          createdOn: '2022-02-06T09:56:07.291Z',
          transactionType: 'debit',
          amount: 5000,
          balance: 1782100
        }
      ],
      gameWalletPayment: [],
      pokerWalletPayment: [
        {
          _id: '61febfa5670a6a0021b97944',
          amount: 5000,
          teamId: '61febfa44479ad0025ac7eec',
          transactionType: 'credit',
          balance: 123109.2
        },
        {
          _id: '61fec130670a6a0021b9796d',
          amount: 12900,
          teamId: '61fec1304479ad0025ac81e2',
          transactionType: 'credit',
          balance: 376009.2
        },
        {
          _id: '61ff9b3b670a6a0021b97a2b',
          amount: 5000,
          teamId: '61ff9b3b4479ad0025acdb07',
          transactionType: 'credit',
          balance: 714809.2
        }
      ],
      bonusWalletPayment: [],
      cashbackWalletPayment: []
    },
    {
      _id: '61febf99670a6a0021b9793f',
      entryFee: 5000,
      bonusFee: 0,
      gameId: '61dea9e61a28e80023bf2e97',
      game: 'poker',
      userId: '601cd58656c4dd5b565191e9',
      createdOn: '2022-02-05T18:19:05.220Z',
      primaryWalletPayment: [
        {
          _id: '61febf99670a6a0021b97940',
          teamId: '61febf994479ad0025ac7eb2',
          createdOn: '2022-02-05T18:19:05.220Z',
          transactionType: 'debit',
          amount: 5000,
          balance: 2403800
        },
        {
          _id: '61fec15b670a6a0021b9797d',
          teamId: '61fec15b4479ad0025ac82c7',
          createdOn: '2022-02-05T18:26:35.596Z',
          transactionType: 'debit',
          amount: 5000,
          balance: 1990900
        },
        {
          _id: '61fec22e670a6a0021b9798e',
          teamId: '61fec22e4479ad0025ac8422',
          createdOn: '2022-02-05T18:30:06.656Z',
          transactionType: 'debit',
          amount: 5000,
          balance: 1976100
        },
        {
          _id: '61fec40b670a6a0021b979ae',
          teamId: '61fec40b4479ad0025ac86b5',
          createdOn: '2022-02-05T18:38:03.299Z',
          transactionType: 'debit',
          amount: 5000,
          balance: 1789100
        },
        {
          _id: '61ff9bcb670a6a0021b97a5a',
          teamId: '61ff9bcb4479ad0025acddfd',
          createdOn: '2022-02-06T09:58:35.563Z',
          transactionType: 'debit',
          amount: 5000,
          balance: 1462100
        },
        {
          _id: '61ff9f07670a6a0021b97a82',
          teamId: '61ff9f074479ad0025ace18e',
          createdOn: '2022-02-06T10:12:23.446Z',
          transactionType: 'debit',
          amount: 5000,
          balance: 1265800
        }
      ],
      gameWalletPayment: [],
      pokerWalletPayment: [
        {
          _id: '61febf9b670a6a0021b97941',
          amount: 5000,
          teamId: '61febf9b4479ad0025ac7ec0',
          transactionType: 'credit',
          balance: 118109.2
        },
        {
          _id: '61fec172670a6a0021b97984',
          amount: 5000,
          teamId: '61fec1724479ad0025ac833e',
          transactionType: 'credit',
          balance: 508009.2
        },
        {
          _id: '61fec243670a6a0021b97995',
          amount: 5000,
          teamId: '61fec2434479ad0025ac849b',
          transactionType: 'credit',
          balance: 520809.2
        },
        {
          _id: '61fec40e670a6a0021b979af',
          amount: 5000,
          teamId: '61fec40e4479ad0025ac86c5',
          transactionType: 'credit',
          balance: 707809.2
        },
        {
          _id: '61ff9bd3670a6a0021b97a5b',
          amount: 5000,
          teamId: '61ff9bd24479ad0025acde0c',
          transactionType: 'credit',
          balance: 1034809.2
        },
        {
          _id: '61ff9f1f670a6a0021b97a89',
          amount: 5000,
          teamId: '61ff9f1f4479ad0025ace1fb',
          transactionType: 'credit',
          balance: 1231109.2
        }
      ],
      bonusWalletPayment: [],
      cashbackWalletPayment: []
    },
    {
      _id: '61febf64670a6a0021b97934',
      entryFee: 25000,
      bonusFee: 0,
      gameId: '61b738c820cbf800263fc0ba',
      game: 'poker',
      userId: '601cd58656c4dd5b565191e9',
      createdOn: '2022-02-05T18:18:12.764Z',
      primaryWalletPayment: [
        {
          _id: '61febf64670a6a0021b97935',
          teamId: '61febf644479ad0025ac7deb',
          createdOn: '2022-02-05T18:18:12.764Z',
          transactionType: 'debit',
          amount: 25000,
          balance: 2411200
        },
        {
          _id: '61febfc6670a6a0021b97952',
          teamId: '61febfc64479ad0025ac7fd3',
          createdOn: '2022-02-05T18:19:50.226Z',
          transactionType: 'debit',
          amount: 25000,
          balance: 2313800
        },
        {
          _id: '61fec134670a6a0021b9796f',
          teamId: '61fec1334479ad0025ac81ff',
          createdOn: '2022-02-05T18:25:56.290Z',
          transactionType: 'debit',
          amount: 25000,
          balance: 2095900
        },
        {
          _id: '61fec134670a6a0021b97971',
          teamId: '61fec1344479ad0025ac8204',
          createdOn: '2022-02-05T18:25:56.657Z',
          transactionType: 'debit',
          amount: 25000,
          balance: 2070900
        },
        {
          _id: '61fec24f670a6a0021b9799a',
          teamId: '61fec24f4479ad0025ac84e7',
          createdOn: '2022-02-05T18:30:39.698Z',
          transactionType: 'debit',
          amount: 25000,
          balance: 1896100
        },
        {
          _id: '61ff9b68670a6a0021b97a39',
          teamId: '61ff9b684479ad0025acdbf4',
          createdOn: '2022-02-06T09:56:56.841Z',
          transactionType: 'debit',
          amount: 25000,
          balance: 1697100
        },
        {
          _id: '61ff9bb2670a6a0021b97a54',
          teamId: '61ff9bb24479ad0025acdd9a',
          createdOn: '2022-02-06T09:58:10.958Z',
          transactionType: 'debit',
          amount: 25000,
          balance: 1472100
        },
        {
          _id: '61ff9ed2670a6a0021b97a6e',
          teamId: '61ff9ed14479ad0025ace057',
          createdOn: '2022-02-06T10:11:30.079Z',
          transactionType: 'debit',
          amount: 25000,
          balance: 1376200
        },
        {
          _id: '61ff9ee6670a6a0021b97a75',
          teamId: '61ff9ee54479ad0025ace0cd',
          createdOn: '2022-02-06T10:11:50.107Z',
          transactionType: 'debit',
          amount: 25000,
          balance: 1350800
        },
        {
          _id: '61ff9f45670a6a0021b97a8d',
          teamId: '61ff9f454479ad0025ace24c',
          createdOn: '2022-02-06T10:13:25.653Z',
          transactionType: 'debit',
          amount: 25000,
          balance: 1190800
        }
      ],
      gameWalletPayment: [],
      pokerWalletPayment: [
        {
          _id: '61febf6f670a6a0021b97938',
          amount: 25000,
          teamId: '61febf6f4479ad0025ac7e24',
          transactionType: 'credit',
          balance: 110709.2
        },
        {
          _id: '61febfc9670a6a0021b97953',
          amount: 25000,
          teamId: '61febfc94479ad0025ac7fe1',
          transactionType: 'credit',
          balance: 208109.2
        },
        {
          _id: '61fec13e670a6a0021b97974',
          amount: 25000,
          teamId: '61fec13e4479ad0025ac8239',
          transactionType: 'credit',
          balance: 401009.2
        },
        {
          _id: '61fec285670a6a0021b979a9',
          amount: 25000,
          teamId: '61fec2854479ad0025ac85e2',
          transactionType: 'credit',
          balance: 700809.2
        },
        {
          _id: '61ff9b6c670a6a0021b97a3a',
          amount: 25000,
          teamId: '61ff9b6b4479ad0025acdc01',
          transactionType: 'credit',
          balance: 799809.2
        },
        {
          _id: '61ff9bb6670a6a0021b97a55',
          amount: 25000,
          teamId: '61ff9bb54479ad0025acdda8',
          transactionType: 'credit',
          balance: 1024809.2
        },
        {
          _id: '61ff9ed4670a6a0021b97a6f',
          amount: 25000,
          teamId: '61ff9ed44479ad0025ace065',
          transactionType: 'credit',
          balance: 1095709.2
        },
        {
          _id: '61ff9f0f670a6a0021b97a84',
          amount: 25000,
          teamId: '61ff9f0f4479ad0025ace1b3',
          transactionType: 'credit',
          balance: 1226109.2
        },
        {
          _id: '61ff9f55670a6a0021b97a93',
          amount: 25000,
          teamId: '61ff9f554479ad0025ace2ad',
          transactionType: 'credit',
          balance: 1311109.2
        }
      ],
      bonusWalletPayment: [],
      cashbackWalletPayment: []
    },
    {
      _id: '61febf55670a6a0021b9792e',
      entryFee: 25000,
      bonusFee: 0,
      gameId: '61b738de20cbf800263fc0dd',
      game: 'poker',
      userId: '601cd58656c4dd5b565191e9',
      createdOn: '2022-02-05T18:17:57.308Z',
      primaryWalletPayment: [
        {
          _id: '61febf55670a6a0021b9792f',
          teamId: '61febf554479ad0025ac7d89',
          createdOn: '2022-02-05T18:17:57.308Z',
          transactionType: 'debit',
          amount: 25000,
          balance: 2441200
        },
        {
          _id: '61febfbe670a6a0021b9794f',
          teamId: '61febfbe4479ad0025ac7fa7',
          createdOn: '2022-02-05T18:19:42.602Z',
          transactionType: 'debit',
          amount: 25000,
          balance: 2338800
        },
        {
          _id: '61fec126670a6a0021b9796b',
          teamId: '61fec1264479ad0025ac81bd',
          createdOn: '2022-02-05T18:25:42.628Z',
          transactionType: 'debit',
          amount: 25000,
          balance: 2120900
        },
        {
          _id: '61fec24c670a6a0021b97998',
          teamId: '61fec24b4479ad0025ac84ce',
          createdOn: '2022-02-05T18:30:36.086Z',
          transactionType: 'debit',
          amount: 25000,
          balance: 1921100
        },
        {
          _id: '61ff9b60670a6a0021b97a36',
          teamId: '61ff9b5f4479ad0025acdbc7',
          createdOn: '2022-02-06T09:56:48.145Z',
          transactionType: 'debit',
          amount: 25000,
          balance: 1722100
        },
        {
          _id: '61ff9bef670a6a0021b97a63',
          teamId: '61ff9bef4479ad0025acde94',
          createdOn: '2022-02-06T09:59:11.352Z',
          transactionType: 'debit',
          amount: 25000,
          balance: 1431700
        },
        {
          _id: '61ff9ef8670a6a0021b97a7c',
          teamId: '61ff9ef84479ad0025ace133',
          createdOn: '2022-02-06T10:12:08.353Z',
          transactionType: 'debit',
          amount: 25000,
          balance: 1275800
        },
        {
          _id: '61ff9f5f670a6a0021b97a97',
          teamId: '61ff9f5f4479ad0025ace2ea',
          createdOn: '2022-02-06T10:13:51.958Z',
          transactionType: 'debit',
          amount: 25000,
          balance: 1159900
        }
      ],
      gameWalletPayment: [],
      pokerWalletPayment: [
        {
          _id: '61febf57670a6a0021b97930',
          amount: 25000,
          teamId: '61febf574479ad0025ac7d98',
          transactionType: 'credit',
          balance: 50709.2
        },
        {
          _id: '61febfc0670a6a0021b97950',
          amount: 25000,
          teamId: '61febfc04479ad0025ac7fb4',
          transactionType: 'credit',
          balance: 183109.2
        },
        {
          _id: '61fec14a670a6a0021b97977',
          amount: 25000,
          teamId: '61fec14a4479ad0025ac8267',
          transactionType: 'credit',
          balance: 426009.2
        },
        {
          _id: '61fec25f670a6a0021b9799e',
          amount: 25000,
          teamId: '61fec25e4479ad0025ac8528',
          transactionType: 'credit',
          balance: 575809.2
        },
        {
          _id: '61ff9b63670a6a0021b97a37',
          amount: 25000,
          teamId: '61ff9b634479ad0025acdbd5',
          transactionType: 'credit',
          balance: 774809.2
        },
        {
          _id: '61ff9bf2670a6a0021b97a64',
          amount: 25000,
          teamId: '61ff9bf24479ad0025acdea2',
          transactionType: 'credit',
          balance: 1065209.2
        },
        {
          _id: '61ff9efe670a6a0021b97a7e',
          amount: 25000,
          teamId: '61ff9efe4479ad0025ace151',
          transactionType: 'credit',
          balance: 1196109.2
        },
        {
          _id: '61ff9f7f670a6a0021b97aa2',
          amount: 25000,
          teamId: '61ff9f7f4479ad0025ace3a9',
          transactionType: 'credit',
          balance: 1367009.2
        }
      ],
      bonusWalletPayment: [],
      cashbackWalletPayment: []
    },
    {
      _id: '61febf4e670a6a0021b9792c',
      entryFee: 25000,
      bonusFee: 0,
      gameId: '61bc42d2f75e400024834f7b',
      game: 'poker',
      userId: '601cd58656c4dd5b565191e9',
      createdOn: '2022-02-05T18:17:50.932Z',
      primaryWalletPayment: [
        {
          _id: '61febf4e670a6a0021b9792d',
          teamId: '61febf4e4479ad0025ac7d70',
          createdOn: '2022-02-05T18:17:50.932Z',
          transactionType: 'debit',
          amount: 25000,
          balance: 2466200
        },
        {
          _id: '61febfb7670a6a0021b9794c',
          teamId: '61febfb74479ad0025ac7f78',
          createdOn: '2022-02-05T18:19:35.813Z',
          transactionType: 'debit',
          amount: 25000,
          balance: 2363800
        },
        {
          _id: '61fec23f670a6a0021b97994',
          teamId: '61fec23f4479ad0025ac848c',
          createdOn: '2022-02-05T18:30:23.460Z',
          transactionType: 'debit',
          amount: 25000,
          balance: 1946100
        },
        {
          _id: '61ff9b54670a6a0021b97a33',
          teamId: '61ff9b534479ad0025acdb93',
          createdOn: '2022-02-06T09:56:36.111Z',
          transactionType: 'debit',
          amount: 25000,
          balance: 1747100
        },
        {
          _id: '61ff9ece670a6a0021b97a6c',
          teamId: '61ff9ecd4479ad0025ace03f',
          createdOn: '2022-02-06T10:11:26.049Z',
          transactionType: 'debit',
          amount: 25000,
          balance: 1401200
        }
      ],
      gameWalletPayment: [],
      pokerWalletPayment: [
        {
          _id: '61febf6c670a6a0021b97937',
          amount: 25000,
          teamId: '61febf6c4479ad0025ac7e10',
          transactionType: 'credit',
          balance: 85709.2
        },
        {
          _id: '61febfba670a6a0021b9794d',
          amount: 25000,
          teamId: '61febfba4479ad0025ac7f87',
          transactionType: 'credit',
          balance: 158109.2
        },
        {
          _id: '61fec26d670a6a0021b979a2',
          amount: 25000,
          teamId: '61fec26d4479ad0025ac8570',
          transactionType: 'credit',
          balance: 625809.2
        },
        {
          _id: '61ff9b58670a6a0021b97a34',
          amount: 25000,
          teamId: '61ff9b574479ad0025acdba2',
          transactionType: 'credit',
          balance: 749809.2
        },
        {
          _id: '61ff9ee0670a6a0021b97a73',
          amount: 25000,
          teamId: '61ff9ee04479ad0025ace0ac',
          transactionType: 'credit',
          balance: 1121109.2
        }
      ],
      bonusWalletPayment: [],
      cashbackWalletPayment: []
    },
    {
      _id: '61febf46670a6a0021b9792a',
      entryFee: 5000,
      bonusFee: 0,
      gameId: '6194a67fb5cce5001ae0bbe7',
      game: 'poker',
      userId: '601cd58656c4dd5b565191e9',
      createdOn: '2022-02-05T18:17:42.457Z',
      primaryWalletPayment: [
        {
          _id: '61febf46670a6a0021b9792b',
          teamId: '61febf464479ad0025ac7d52',
          createdOn: '2022-02-05T18:17:42.457Z',
          transactionType: 'debit',
          amount: 5000,
          balance: 2491200
        },
        {
          _id: '61febfa9670a6a0021b97946',
          teamId: '61febfa94479ad0025ac7f10',
          createdOn: '2022-02-05T18:19:21.542Z',
          transactionType: 'debit',
          amount: 5000,
          balance: 2393800
        },
        {
          _id: '61ff9b40670a6a0021b97a2d',
          teamId: '61ff9b404479ad0025acdb2b',
          createdOn: '2022-02-06T09:56:16.996Z',
          transactionType: 'debit',
          amount: 5000,
          balance: 1777100
        },
        {
          _id: '61ff9bbd670a6a0021b97a57',
          teamId: '61ff9bbd4479ad0025acddcc',
          createdOn: '2022-02-06T09:58:21.210Z',
          transactionType: 'debit',
          amount: 5000,
          balance: 1467100
        },
        {
          _id: '61ff9f02670a6a0021b97a80',
          teamId: '61ff9f024479ad0025ace176',
          createdOn: '2022-02-06T10:12:18.545Z',
          transactionType: 'debit',
          amount: 5000,
          balance: 1270800
        },
        {
          _id: '61ff9f4a670a6a0021b97a8f',
          teamId: '61ff9f494479ad0025ace26b',
          createdOn: '2022-02-06T10:13:30.091Z',
          transactionType: 'debit',
          amount: 5000,
          balance: 1185800
        }
      ],
      gameWalletPayment: [],
      pokerWalletPayment: [
        {
          _id: '61febf5f670a6a0021b97933',
          amount: 5000,
          teamId: '61febf5f4479ad0025ac7dc9',
          transactionType: 'credit',
          balance: 55709.2
        },
        {
          _id: '61febfab670a6a0021b97947',
          amount: 5000,
          teamId: '61febfab4479ad0025ac7f1d',
          transactionType: 'credit',
          balance: 128109.2
        },
        {
          _id: '61ff9b44670a6a0021b97a2e',
          amount: 5000,
          teamId: '61ff9b434479ad0025acdb38',
          transactionType: 'credit',
          balance: 719809.2
        },
        {
          _id: '61ff9bc2670a6a0021b97a58',
          amount: 5000,
          teamId: '61ff9bc14479ad0025acdddb',
          transactionType: 'credit',
          balance: 1029809.2
        },
        {
          _id: '61ff9f0c670a6a0021b97a83',
          amount: 5000,
          teamId: '61ff9f0c4479ad0025ace19e',
          transactionType: 'credit',
          balance: 1201109.2
        },
        {
          _id: '61ff9f51670a6a0021b97a92',
          amount: 5000,
          teamId: '61ff9f514479ad0025ace297',
          transactionType: 'credit',
          balance: 1286109.2
        }
      ],
      bonusWalletPayment: [],
      cashbackWalletPayment: []
    },
    {
      _id: '61febd3c670a6a0021b97907',
      entryFee: 500,
      bonusFee: 0,
      gameId: '61e81f94073b5d00246864f3',
      game: 'poker',
      userId: '601cd58656c4dd5b565191e9',
      createdOn: '2022-02-05T18:09:00.890Z',
      primaryWalletPayment: [
        {
          _id: '61febd3c670a6a0021b97908',
          teamId: '61febd3c4479ad0025ac79ec',
          createdOn: '2022-02-05T18:09:00.890Z',
          transactionType: 'debit',
          amount: 500,
          balance: 2516100
        },
        {
          _id: '61febd46670a6a0021b9790a',
          teamId: '61febd464479ad0025ac7a03',
          createdOn: '2022-02-05T18:09:10.869Z',
          transactionType: 'debit',
          amount: 1500,
          balance: 2514600
        },
        {
          _id: '61febd60670a6a0021b9790d',
          teamId: '61febd604479ad0025ac7a3c',
          createdOn: '2022-02-05T18:09:36.385Z',
          transactionType: 'debit',
          amount: 2000,
          balance: 2512600
        },
        {
          _id: '61febd9b670a6a0021b97910',
          teamId: '61febd9a4479ad0025ac7a84',
          createdOn: '2022-02-05T18:10:35.165Z',
          transactionType: 'debit',
          amount: 2000,
          balance: 2510600
        },
        {
          _id: '61febda5670a6a0021b97913',
          teamId: '61febda44479ad0025ac7ab8',
          createdOn: '2022-02-05T18:10:45.067Z',
          transactionType: 'debit',
          amount: 2000,
          balance: 2508600
        },
        {
          _id: '61febdb3670a6a0021b97916',
          teamId: '61febdb34479ad0025ac7aef',
          createdOn: '2022-02-05T18:10:59.521Z',
          transactionType: 'debit',
          amount: 2000,
          balance: 2506600
        },
        {
          _id: '61febdbe670a6a0021b97919',
          teamId: '61febdbe4479ad0025ac7b24',
          createdOn: '2022-02-05T18:11:10.956Z',
          transactionType: 'debit',
          amount: 2000,
          balance: 2504600
        },
        {
          _id: '61febdca670a6a0021b9791c',
          teamId: '61febdca4479ad0025ac7b6c',
          createdOn: '2022-02-05T18:11:22.834Z',
          transactionType: 'debit',
          amount: 2000,
          balance: 2502600
        },
        {
          _id: '61febdde670a6a0021b9791f',
          teamId: '61febdde4479ad0025ac7bc4',
          createdOn: '2022-02-05T18:11:42.417Z',
          transactionType: 'debit',
          amount: 2000,
          balance: 2500600
        },
        {
          _id: '61febe21670a6a0021b97922',
          teamId: '61febe204479ad0025ac7c32',
          createdOn: '2022-02-05T18:12:49.075Z',
          transactionType: 'debit',
          amount: 2000,
          balance: 2498600
        },
        {
          _id: '61febedc670a6a0021b97925',
          teamId: '61febedc4479ad0025ac7cb6',
          createdOn: '2022-02-05T18:15:56.729Z',
          transactionType: 'debit',
          amount: 2000,
          balance: 2496600
        },
        {
          _id: '61febf8b670a6a0021b9793a',
          teamId: '61febf8b4479ad0025ac7e51',
          createdOn: '2022-02-05T18:18:51.465Z',
          transactionType: 'debit',
          amount: 2000,
          balance: 2409200
        },
        {
          _id: '61fec161670a6a0021b9797f',
          teamId: '61fec1614479ad0025ac82e8',
          createdOn: '2022-02-05T18:26:41.668Z',
          transactionType: 'debit',
          amount: 2000,
          balance: 1988900
        },
        {
          _id: '61fec223670a6a0021b9798a',
          teamId: '61fec2224479ad0025ac83e5',
          createdOn: '2022-02-05T18:29:55.002Z',
          transactionType: 'debit',
          amount: 2000,
          balance: 1981500
        },
        {
          _id: '61fec3ff670a6a0021b979ab',
          teamId: '61fec3fe4479ad0025ac868e',
          createdOn: '2022-02-05T18:37:51.147Z',
          transactionType: 'debit',
          amount: 2000,
          balance: 1794100
        },
        {
          _id: '61ff9971670a6a0021b97a1e',
          teamId: '61ff99714479ad0025acd994',
          createdOn: '2022-02-06T09:48:33.946Z',
          transactionType: 'debit',
          amount: 500,
          balance: 1788600
        },
        {
          _id: '61ff9abd670a6a0021b97a21',
          teamId: '61ff9abd4479ad0025acda41',
          createdOn: '2022-02-06T09:54:05.636Z',
          transactionType: 'debit',
          amount: 500,
          balance: 1788100
        },
        {
          _id: '61ff9b02670a6a0021b97a24',
          teamId: '61ff9b024479ad0025acda89',
          createdOn: '2022-02-06T09:55:14.394Z',
          transactionType: 'debit',
          amount: 500,
          balance: 1787600
        },
        {
          _id: '61ff9b28670a6a0021b97a27',
          teamId: '61ff9b284479ad0025acdac8',
          createdOn: '2022-02-06T09:55:52.938Z',
          transactionType: 'debit',
          amount: 500,
          balance: 1787100
        },
        {
          _id: '61ff9ebf670a6a0021b97a69',
          teamId: '61ff9ebf4479ad0025ace004',
          createdOn: '2022-02-06T10:11:11.410Z',
          transactionType: 'debit',
          amount: 500,
          balance: 1426200
        },
        {
          _id: '61ff9f5b670a6a0021b97a95',
          teamId: '61ff9f5b4479ad0025ace2d2',
          createdOn: '2022-02-06T10:13:47.664Z',
          transactionType: 'debit',
          amount: 500,
          balance: 1184900
        },
        {
          _id: '6200d2ed670a6a0021b97b78',
          teamId: '6200d2ed4479ad0025ad6b2a',
          createdOn: '2022-02-07T08:06:05.864Z',
          transactionType: 'debit',
          amount: 500,
          balance: 104040
        },
        {
          _id: '6207be0204a2d0002015b914',
          teamId: '6207be024af4190029921e71',
          createdOn: '2022-02-12T14:02:42.378Z',
          transactionType: 'debit',
          amount: 500,
          balance: 1228900
        }
      ],
      gameWalletPayment: [],
      pokerWalletPayment: [
        {
          _id: '61febd57670a6a0021b9790b',
          amount: 2000,
          teamId: '61febd574479ad0025ac7a15',
          transactionType: 'credit',
          balance: 7309.2
        },
        {
          _id: '61febd93670a6a0021b9790e',
          amount: 2000,
          teamId: '61febd934479ad0025ac7a5e',
          transactionType: 'credit',
          balance: 9309.2
        },
        {
          _id: '61febd9e670a6a0021b97911',
          amount: 2000,
          teamId: '61febd9e4479ad0025ac7a93',
          transactionType: 'credit',
          balance: 11309.2
        },
        {
          _id: '61febda8670a6a0021b97914',
          amount: 2000,
          teamId: '61febda84479ad0025ac7ac7',
          transactionType: 'credit',
          balance: 13309.2
        },
        {
          _id: '61febdb9670a6a0021b97917',
          amount: 2000,
          teamId: '61febdb94479ad0025ac7afe',
          transactionType: 'credit',
          balance: 15309.2
        },
        {
          _id: '61febdc1670a6a0021b9791a',
          amount: 2000,
          teamId: '61febdc14479ad0025ac7b32',
          transactionType: 'credit',
          balance: 17309.2
        },
        {
          _id: '61febdd8670a6a0021b9791d',
          amount: 2000,
          teamId: '61febdd84479ad0025ac7b9d',
          transactionType: 'credit',
          balance: 19309.2
        },
        {
          _id: '61febdf9670a6a0021b97920',
          amount: 2000,
          teamId: '61febdf94479ad0025ac7c01',
          transactionType: 'credit',
          balance: 21309.2
        },
        {
          _id: '61febe54670a6a0021b97923',
          amount: 2000,
          teamId: '61febe544479ad0025ac7c61',
          transactionType: 'credit',
          balance: 23309.2
        },
        {
          _id: '61febf37670a6a0021b97926',
          amount: 2000,
          teamId: '61febf374479ad0025ac7cf6',
          transactionType: 'credit',
          balance: 25309.2
        },
        {
          _id: '61febf8e670a6a0021b9793b',
          amount: 2000,
          teamId: '61febf8e4479ad0025ac7e5f',
          transactionType: 'credit',
          balance: 112709.2
        },
        {
          _id: '61fec163670a6a0021b97980',
          amount: 2000,
          teamId: '61fec1634479ad0025ac82f5',
          transactionType: 'credit',
          balance: 478009.2
        },
        {
          _id: '61fec231670a6a0021b9798f',
          amount: 2000,
          teamId: '61fec2314479ad0025ac8431',
          transactionType: 'credit',
          balance: 515409.2
        },
        {
          _id: '61fec409670a6a0021b979ac',
          amount: 2000,
          teamId: '61fec4094479ad0025ac869e',
          transactionType: 'credit',
          balance: 702809.2
        },
        {
          _id: '61ff99b2670a6a0021b97a1f',
          amount: 500,
          teamId: '61ff99b24479ad0025acd9b8',
          transactionType: 'credit',
          balance: 708309.2
        },
        {
          _id: '61ff9ae3670a6a0021b97a22',
          amount: 500,
          teamId: '61ff9ae24479ad0025acda5a',
          transactionType: 'credit',
          balance: 708809.2
        },
        {
          _id: '61ff9b16670a6a0021b97a25',
          amount: 500,
          teamId: '61ff9b164479ad0025acda9e',
          transactionType: 'credit',
          balance: 709309.2
        },
        {
          _id: '61ff9b2e670a6a0021b97a28',
          amount: 500,
          teamId: '61ff9b2e4479ad0025acdad7',
          transactionType: 'credit',
          balance: 709809.2
        },
        {
          _id: '61ff9ec7670a6a0021b97a6a',
          amount: 500,
          teamId: '61ff9ec74479ad0025ace014',
          transactionType: 'credit',
          balance: 1070709.2
        },
        {
          _id: '61ff9f6b670a6a0021b97a9b',
          amount: 500,
          teamId: '61ff9f6a4479ad0025ace32a',
          transactionType: 'credit',
          balance: 1316609.2
        },
        {
          _id: '6200d2f1670a6a0021b97b79',
          amount: 500,
          teamId: '6200d2f14479ad0025ad6b38',
          transactionType: 'credit',
          balance: 1392509.2
        },
        {
          _id: '6207c51004a2d0002015b919',
          amount: 500,
          teamId: '6207c5104af419002992216d',
          transactionType: 'credit',
          balance: 1393009.2
        }
      ],
      bonusWalletPayment: [],
      cashbackWalletPayment: []
    },
    {
      _id: '61e51f3c2958f3001fb274d2',
      entryFee: 400,
      bonusFee: 0,
      gameId: '619b6ed65504820023abf810',
      game: 'poker',
      userId: '601cd58656c4dd5b565191e9',
      createdOn: '2022-01-17T07:48:12.230Z',
      primaryWalletPayment: [
        {
          _id: '61e51f3c2958f3001fb274d3',
          teamId: '61e51f3cdd2d1200231d92b9',
          createdOn: '2022-01-17T07:48:12.230Z',
          transactionType: 'debit',
          amount: 400,
          balance: 681400
        },
        {
          _id: '61f5245511fae10020fa57e6',
          teamId: '61f524550a51e100237771e1',
          createdOn: '2022-01-29T11:26:13.801Z',
          transactionType: 'debit',
          amount: 400,
          balance: 1913100
        },
        {
          _id: '61febf3d670a6a0021b97928',
          teamId: '61febf3d4479ad0025ac7d1b',
          createdOn: '2022-02-05T18:17:33.214Z',
          transactionType: 'debit',
          amount: 400,
          balance: 2496200
        },
        {
          _id: '61febf92670a6a0021b9793d',
          teamId: '61febf924479ad0025ac7e85',
          createdOn: '2022-02-05T18:18:58.911Z',
          transactionType: 'debit',
          amount: 400,
          balance: 2408800
        },
        {
          _id: '61fec169670a6a0021b97982',
          teamId: '61fec1694479ad0025ac831c',
          createdOn: '2022-02-05T18:26:49.694Z',
          transactionType: 'debit',
          amount: 400,
          balance: 1988500
        },
        {
          _id: '61fec228670a6a0021b9798c',
          teamId: '61fec2274479ad0025ac8407',
          createdOn: '2022-02-05T18:30:00.053Z',
          transactionType: 'debit',
          amount: 400,
          balance: 1981100
        },
        {
          _id: '61ff9bdd670a6a0021b97a5d',
          teamId: '61ff9bdd4479ad0025acde31',
          createdOn: '2022-02-06T09:58:53.254Z',
          transactionType: 'debit',
          amount: 400,
          balance: 1461700
        },
        {
          _id: '61ff9ed9670a6a0021b97a71',
          teamId: '61ff9ed94479ad0025ace088',
          createdOn: '2022-02-06T10:11:37.871Z',
          transactionType: 'debit',
          amount: 400,
          balance: 1375800
        },
        {
          _id: '61ff9f4d670a6a0021b97a91',
          teamId: '61ff9f4d4479ad0025ace288',
          createdOn: '2022-02-06T10:13:33.802Z',
          transactionType: 'debit',
          amount: 400,
          balance: 1185400
        }
      ],
      gameWalletPayment: [],
      pokerWalletPayment: [
        {
          _id: '61e51f952958f3001fb274d4',
          amount: 400,
          teamId: '61e51f95dd2d1200231d93a4',
          transactionType: 'credit',
          balance: 2102.2
        },
        {
          _id: '61f5252311fae10020fa57e7',
          amount: 359.99999999999994,
          teamId: '61f525220a51e100237772b2',
          transactionType: 'credit',
          balance: 5309.2
        },
        {
          _id: '61febf40670a6a0021b97929',
          amount: 400,
          teamId: '61febf404479ad0025ac7d29',
          transactionType: 'credit',
          balance: 25709.2
        },
        {
          _id: '61febf95670a6a0021b9793e',
          amount: 400,
          teamId: '61febf944479ad0025ac7e92',
          transactionType: 'credit',
          balance: 113109.2
        },
        {
          _id: '61fec17f670a6a0021b97987',
          amount: 400,
          teamId: '61fec17f4479ad0025ac8373',
          transactionType: 'credit',
          balance: 508409.2
        },
        {
          _id: '61fec235670a6a0021b97990',
          amount: 400,
          teamId: '61fec2354479ad0025ac8446',
          transactionType: 'credit',
          balance: 515809.2
        },
        {
          _id: '61ff9be1670a6a0021b97a5e',
          amount: 400,
          teamId: '61ff9be14479ad0025acde40',
          transactionType: 'credit',
          balance: 1035209.2
        },
        {
          _id: '61ff9edd670a6a0021b97a72',
          amount: 400,
          teamId: '61ff9edc4479ad0025ace096',
          transactionType: 'credit',
          balance: 1096109.2
        },
        {
          _id: '61ff9f6e670a6a0021b97a9c',
          amount: 400,
          teamId: '61ff9f6e4479ad0025ace341',
          transactionType: 'credit',
          balance: 1317009.2
        }
      ],
      bonusWalletPayment: [],
      cashbackWalletPayment: []
    },
    {
      _id: '61e513722958f3001fb274b0',
      entryFee: 2000,
      bonusFee: 0,
      gameId: '619b880d5504820023abf97c',
      game: 'poker',
      userId: '601cd58656c4dd5b565191e9',
      createdOn: '2022-01-17T06:57:54.210Z',
      primaryWalletPayment: [
        {
          _id: '61e513722958f3001fb274b1',
          teamId: '61e51372dd2d1200231d7c42',
          createdOn: '2022-01-17T06:57:54.210Z',
          transactionType: 'debit',
          amount: 2000,
          balance: 683700
        },
        {
          _id: '61e51d9a2958f3001fb274ba',
          teamId: '61e51d9add2d1200231d8dd7',
          createdOn: '2022-01-17T07:41:14.305Z',
          transactionType: 'debit',
          amount: 1900,
          balance: 681800
        },
        {
          _id: '61e5b8dca439dd001e9a64e2',
          teamId: '61e5b8db09dd530026fea391',
          createdOn: '2022-01-17T18:43:40.113Z',
          transactionType: 'debit',
          amount: 400,
          balance: 681000
        }
      ],
      gameWalletPayment: [],
      pokerWalletPayment: [
        {
          _id: '61e51c0e2958f3001fb274b8',
          amount: 1702.1999999999998,
          teamId: '61e51c0edd2d1200231d8b5a',
          transactionType: 'credit',
          balance: 1702.1999999999998
        },
        {
          _id: '61e521682958f3001fb274d5',
          amount: 2447,
          teamId: '61e52168dd2d1200231d94c4',
          transactionType: 'credit',
          balance: 4549.2
        },
        {
          _id: '61e5b8ffa439dd001e9a64e3',
          amount: 400,
          teamId: '61e5b8ff09dd530026fea3cb',
          transactionType: 'credit',
          balance: 4949.2
        }
      ],
      bonusWalletPayment: [],
      cashbackWalletPayment: []
    },
    {
      _id: '61c2db2cf8700e001e1da9c3',
      entryFee: 5000,
      bonusFee: 0,
      gameId: '61bc47b1f75e40002483525e',
      game: 'poker',
      userId: '601cd58656c4dd5b565191e9',
      createdOn: '2021-12-22T08:00:44.481Z',
      primaryWalletPayment: [
        {
          _id: '61c2db2cf8700e001e1da9c4',
          teamId: '61c2db2c948de80023771edc',
          createdOn: '2021-12-22T08:00:44.481Z',
          transactionType: 'debit',
          amount: 5000,
          balance: 7500
        }
      ],
      gameWalletPayment: [],
      pokerWalletPayment: [
        {
          _id: '61c2e238f8700e001e1da9c5',
          amount: 5000,
          teamId: '61c2e238948de800237721c3',
          transactionType: 'credit',
          balance: 530576
        }
      ],
      bonusWalletPayment: [],
      cashbackWalletPayment: []
    },
    {
      _id: '61bc7b71e97477001ce7b58c',
      entryFee: 5000,
      bonusFee: 0,
      gameId: '6193583549f9200022a56675',
      game: 'poker',
      userId: '601cd58656c4dd5b565191e9',
      createdOn: '2021-12-17T11:58:41.074Z',
      primaryWalletPayment: [
        {
          _id: '61febf5c670a6a0021b97932',
          teamId: '61febf5b4479ad0025ac7dbb',
          createdOn: '2022-02-05T18:18:04.000Z',
          transactionType: 'debit',
          amount: 5000,
          balance: 2436200
        },
        {
          _id: '61febfb0670a6a0021b97949',
          teamId: '61febfb04479ad0025ac7f43',
          createdOn: '2022-02-05T18:19:28.639Z',
          transactionType: 'debit',
          amount: 5000,
          balance: 2388800
        },
        {
          _id: '61fec121670a6a0021b97969',
          teamId: '61fec1214479ad0025ac81a1',
          createdOn: '2022-02-05T18:25:37.223Z',
          transactionType: 'debit',
          amount: 5000,
          balance: 2145900
        },
        {
          _id: '61fec178670a6a0021b97986',
          teamId: '61fec1774479ad0025ac8363',
          createdOn: '2022-02-05T18:27:04.032Z',
          transactionType: 'debit',
          amount: 5000,
          balance: 1983500
        },
        {
          _id: '61fec23a670a6a0021b97992',
          teamId: '61fec23a4479ad0025ac846f',
          createdOn: '2022-02-05T18:30:18.915Z',
          transactionType: 'debit',
          amount: 5000,
          balance: 1971100
        },
        {
          _id: '61ff9b4a670a6a0021b97a30',
          teamId: '61ff9b494479ad0025acdb5f',
          createdOn: '2022-02-06T09:56:26.014Z',
          transactionType: 'debit',
          amount: 5000,
          balance: 1772100
        },
        {
          _id: '61ff9be6670a6a0021b97a60',
          teamId: '61ff9be64479ad0025acde65',
          createdOn: '2022-02-06T09:59:02.445Z',
          transactionType: 'debit',
          amount: 5000,
          balance: 1456700
        },
        {
          _id: '61ff9ccc670a6a0021b97a66',
          teamId: '61ff9ccc4479ad0025acdf10',
          createdOn: '2022-02-06T10:02:52.729Z',
          transactionType: 'debit',
          amount: 5000,
          balance: 1426700
        },
        {
          _id: '61ff9f63670a6a0021b97a99',
          teamId: '61ff9f634479ad0025ace308',
          createdOn: '2022-02-06T10:13:55.791Z',
          transactionType: 'debit',
          amount: 5000,
          balance: 1154900
        }
      ],
      gameWalletPayment: [],
      pokerWalletPayment: [
        {
          _id: '61bc7b71e97477001ce7b58d',
          teamId: '61bc7b70c85628002920b84f',
          createdOn: '2021-12-17T11:58:41.074Z',
          transactionType: 'debit',
          amount: 5000,
          balance: 525576
        },
        {
          _id: '61febf68670a6a0021b97936',
          amount: 5000,
          teamId: '61febf684479ad0025ac7df9',
          transactionType: 'credit',
          balance: 60709.2
        },
        {
          _id: '61febfb2670a6a0021b9794a',
          amount: 5000,
          teamId: '61febfb24479ad0025ac7f51',
          transactionType: 'credit',
          balance: 133109.2
        },
        {
          _id: '61fec12d670a6a0021b9796c',
          amount: 5000,
          teamId: '61fec12d4479ad0025ac81cc',
          transactionType: 'credit',
          balance: 363109.2
        },
        {
          _id: '61fec181670a6a0021b97988',
          amount: 5000,
          teamId: '61fec1814479ad0025ac8387',
          transactionType: 'credit',
          balance: 513409.2
        },
        {
          _id: '61fec247670a6a0021b97996',
          amount: 5000,
          teamId: '61fec2474479ad0025ac84ae',
          transactionType: 'credit',
          balance: 525809.2
        },
        {
          _id: '61ff9b4e670a6a0021b97a31',
          amount: 5000,
          teamId: '61ff9b4d4479ad0025acdb6d',
          transactionType: 'credit',
          balance: 724809.2
        },
        {
          _id: '61ff9be9670a6a0021b97a61',
          amount: 5000,
          teamId: '61ff9be94479ad0025acde74',
          transactionType: 'credit',
          balance: 1040209.2
        },
        {
          _id: '61ff9d81670a6a0021b97a67',
          amount: 5000,
          teamId: '61ff9d814479ad0025acdf5c',
          transactionType: 'credit',
          balance: 1070209.2
        },
        {
          _id: '61ff9f68670a6a0021b97a9a',
          amount: 5000,
          teamId: '61ff9f684479ad0025ace317',
          transactionType: 'credit',
          balance: 1316109.2
        }
      ],
      bonusWalletPayment: [],
      cashbackWalletPayment: []
    },
    {
      _id: '619b51f8264e4e0020e9326d',
      entryFee: 50000,
      bonusFee: 0,
      gameId: '6194a6ecb5cce5001ae0bbf2',
      game: 'poker',
      userId: '601cd58656c4dd5b565191e9',
      createdOn: '2021-11-22T08:16:56.006Z',
      primaryWalletPayment: [
        {
          _id: '619b51f8264e4e0020e9326e',
          teamId: '619b51f75504820023abf584',
          createdOn: '2021-11-22T08:16:56.006Z',
          transactionType: 'debit',
          amount: 50000,
          balance: 243180
        }
      ],
      gameWalletPayment: [],
      pokerWalletPayment: [
        {
          _id: '619b5364264e4e0020e9326f',
          amount: 530576,
          teamId: '619b53635504820023abf61e',
          transactionType: 'credit',
          balance: 530576
        }
      ],
      bonusWalletPayment: [],
      cashbackWalletPayment: []
    },
    {
      _id: '61600f3f638e7e001e717ca1',
      entryFee: 82800,
      bonusFee: 0,
      gameId: '614daaabf3bf91001da56521',
      game: 'poker',
      userId: '601cd58656c4dd5b565191e9',
      createdOn: '2021-10-08T09:28:31.103Z',
      primaryWalletPayment: [
        {
          _id: '61600f3f638e7e001e717ca2',
          teamId: '61600f3e938952001a867bb3',
          createdOn: '2021-10-08T09:28:31.103Z',
          transactionType: 'debit',
          amount: 82800,
          balance: 20120
        },
        {
          _id: '61601004638e7e001e717ca5',
          teamId: '61601004938952001a867bc8',
          createdOn: '2021-10-08T09:31:48.550Z',
          transactionType: 'debit',
          amount: 20120,
          balance: 0
        }
      ],
      gameWalletPayment: [],
      pokerWalletPayment: [
        {
          _id: '61601808638e7e001e717cb9',
          amount: 276426,
          teamId: '61601808938952001a867be3',
          transactionType: 'credit',
          balance: 276426
        }
      ],
      bonusWalletPayment: [],
      cashbackWalletPayment: []
    }
  ],
  count: 20
};

export const transactionEarningsBonusWallet = {
  result: [
    {
      _id: '601cd58656c4dd32655191ec',
      userId: '601cd58656c4dd5b565191e9',
      originalEntryFee: 0,
      transactionType: 'credit',
      amount: 10000,
      tax: 0,
      transfer: false,
      refund: false,
      balance: 10000,
      createdOn: '2021-02-05T05:20:06.260Z',
      modifiedOn: '2021-02-05T05:20:06.261Z',
      signupBonus: true
    }
  ],
  amount: 10000,
  count: 1
};
